interface IconInterface { size?: string }

export const Designer = () =>
  <svg
    fill='currentColor'
    viewBox='0 0 22.8 22.8'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.4 22.8a11.4 11.4 0 1 1 8-3.4 11.3 11.3 0 0 1-8 3.4zM5.5 14a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H8v-3h2.5a1 1 0 0 0 1-1V8h2v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1h-2V6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1H7v3zm9-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z'
    />
  </svg>

export const Insights = () =>
  <svg
    fill='currentColor'
    viewBox='0 0 22.76 22.76'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.38 22.76A11.38 11.38 0 0 1 3.33 3.33a11.38 11.38 0 0 1 16.1 16.1 11.3 11.3 0 0 1-8.05 3.33zM4.14 6.06a.34.34 0 0 0-.35.33v9.86a.34.34 0 0 0 .35.32h14.03a.34.34 0 0 0 .34-.33v-1.1a.34.34 0 0 0-.34-.32H5.63V6.39a.34.34 0 0 0-.34-.33zm11.96.87a.34.34 0 0 0-.34.33v6.36a.34.34 0 0 0 .34.32h1.15a.34.34 0 0 0 .35-.32V7.25a.34.34 0 0 0-.35-.33zm-2.76 2.63a.34.34 0 0 0-.35.33v3.72a.34.34 0 0 0 .35.33h1.15a.34.34 0 0 0 .34-.32V9.88a.34.34 0 0 0-.34-.33zm-2.76-1.75a.34.34 0 0 0-.35.33v5.47a.34.34 0 0 0 .35.33h1.15a.34.34 0 0 0 .34-.32V8.13a.34.34 0 0 0-.34-.33zm-2.76 3.5a.34.34 0 0 0-.35.33v1.97a.34.34 0 0 0 .35.33h1.15a.34.34 0 0 0 .34-.32v-1.98a.34.34 0 0 0-.34-.33z'
    />
  </svg>

export const ModelHub = ({ size }: IconInterface) =>
  <svg
    fill='currentColor'
    height={size}
    viewBox='0 0 20.14 16.99'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M321.44 102.91c-.9 0-1.44.35-1.44.54s.55.54 1.44.54 1.44-.35 1.44-.54-.55-.54-1.44-.54z'
      transform='translate(-307.41 -100.44)'
    />
    <path
      d='M129.44 203.48c-.9 0-1.44.35-1.44.54s.55.54 1.44.54 1.44-.35 1.44-.54-.55-.54-1.44-.54z'
      transform='translate(-122.97 -197.05)'
    />
    <path
      d='M225.44 153.2c-.9 0-1.44.35-1.44.54s.55.54 1.44.54 1.44-.35 1.44-.54-.55-.54-1.44-.54z'
      transform='translate(-215.19 -148.75)'
    />
    <path
      d='M192 151.78v6.38l12.59-6.46v-6.39z'
      transform='translate(-184.45 -141.17)'
    />
    <path
      d='M23.24 40.07L10.7 46.5l6.78 3.55L30 43.6zm-6.47 8.22c-1.23 0-2.16-.54-2.16-1.26s.93-1.26 2.16-1.26 2.15.54 2.15 1.26-.92 1.26-2.15 1.26zm3.77-1.98c-1.23 0-2.16-.54-2.16-1.26s.93-1.25 2.16-1.25 2.16.54 2.16 1.26-.93 1.25-2.16 1.25zm3.78-1.97c-1.23 0-2.16-.55-2.16-1.26s.93-1.26 2.16-1.26 2.16.54 2.16 1.26-.93 1.26-2.16 1.26z'
      transform='translate(-10.3 -40.07)'
    />
    <path
      d='M0 224.97l6.83 3.58v-6.38L0 218.6z'
      transform='translate(0 -211.57)'
    />
  </svg>

export const Results = () =>
  <svg
    fill='currentColor'
    viewBox='0 0 17.61 17.61'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.72 0H1.89A1.89 1.89 0 0 0 0 1.89v13.83a1.89 1.89 0 0 0 1.89 1.89h13.83a1.89 1.89 0 0 0 1.89-1.89V1.89A1.89 1.89 0 0 0 15.72 0zM6.29 13.2a.63.63 0 0 1-.63.63H4.4a.63.63 0 0 1-.63-.63V8.17a.63.63 0 0 1 .63-.63h1.26a.63.63 0 0 1 .63.63zm3.77 0a.63.63 0 0 1-.63.63H8.18a.63.63 0 0 1-.63-.63V4.4a.63.63 0 0 1 .63-.63h1.25a.63.63 0 0 1 .63.63zm3.77 0a.63.63 0 0 1-.63.63h-1.25a.63.63 0 0 1-.63-.63v-2.51a.63.63 0 0 1 .63-.63h1.25a.63.63 0 0 1 .63.63z'
    />
  </svg>

export const Rocket = () =>
  <svg
    fill='currentColor'
    viewBox='0 0 22.51 22.51'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.25 22.5a11.18 11.18 0 0 1-4.38-.88 11.22 11.22 0 0 1-3.57-2.4 11.22 11.22 0 0 1-2.42-3.59A11.19 11.19 0 0 1 0 11.25a11.19 11.19 0 0 1 .88-4.38A11.22 11.22 0 0 1 3.3 3.3 11.22 11.22 0 0 1 6.87.88 11.18 11.18 0 0 1 11.25 0a11.18 11.18 0 0 1 4.38.88 11.22 11.22 0 0 1 3.58 2.42 11.22 11.22 0 0 1 2.41 3.57 11.18 11.18 0 0 1 .89 4.38 11.18 11.18 0 0 1-.89 4.38 11.22 11.22 0 0 1-2.4 3.58 11.22 11.22 0 0 1-3.59 2.41 11.18 11.18 0 0 1-4.38.89zm4.16-15.25H7.26A7.6 7.6 0 0 0 7.06 9v2.86a4.49 4.49 0 0 0-1.67 1.23 6.25 6.25 0 0 0-1.14 2.03 9.03 9.03 0 0 0-.49 2.45l-.01.49h1.78l2.1-2.04a9.21 9.21 0 0 0 3.24.77v1.27h.94v-1.27a9.2 9.2 0 0 0 3.23-.77l2.1 2.04h1.8l-.02-.49a8.93 8.93 0 0 0-.49-2.45 6.26 6.26 0 0 0-1.14-2.03 4.49 4.49 0 0 0-1.67-1.23V8.99a7.6 7.6 0 0 0-.2-1.74zM7.82 5.67c-.1.21-.19.42-.27.64h7.57a7.19 7.19 0 0 0-.27-.64zm3.52-3.77L9.78 3.19a7.56 7.56 0 0 0-1.4 1.54h5.92a7.54 7.54 0 0 0-1.4-1.54L11.34 1.9zm0 14.89l-.48-.01V14.2h.95v2.57h-.47zm0-4.14a2.05 2.05 0 0 1-2.06-2.05 2.06 2.06 0 0 1 2.06-2.05 2.06 2.06 0 0 1 2.05 2.05 2.06 2.06 0 0 1-2.05 2.05z'
    />
  </svg>

export const Settings = () =>
  <svg
    fill='currentColor'
    viewBox='0 0 20 20'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 20a10 10 0 1 1 10-10 10 10 0 0 1-10 10zm-4-5.5a5.8 5.8 0 0 0 2 1V17a.4.4 0 0 0 .2.4 7.5 7.5 0 0 0 3.3 0 .4.4 0 0 0 .3-.4v-1.5a5.8 5.8 0 0 0 1.8-1l1.3.7a.4.4 0 0 0 .5 0 7.5 7.5 0 0 0 1.6-2.9.4.4 0 0 0-.2-.4l-1.2-.8a5.8 5.8 0 0 0 0-2l1.2-.8a.4.4 0 0 0 .2-.5A7.5 7.5 0 0 0 15.4 5a.4.4 0 0 0-.5 0l-1.3.7a5.7 5.7 0 0 0-1.8-1.1V3.1a.4.4 0 0 0-.3-.3 7.5 7.5 0 0 0-3.3 0A.4.4 0 0 0 8 3v1.5a5.7 5.7 0 0 0-1.8 1L4.8 5a.4.4 0 0 0-.4 0 7.5 7.5 0 0 0-1.7 3 .4.4 0 0 0 .2.4l1.3.7a5.8 5.8 0 0 0 0 2.1l-1.3.8a.4.4 0 0 0-.2.4 7.5 7.5 0 0 0 1.7 2.9.4.4 0 0 0 .4 0l1.3-.7zm3.9-2a2.4 2.4 0 1 1 2.4-2.4 2.4 2.4 0 0 1-2.4 2.4z'
    />
  </svg>

export const Beaker = () =>
  <svg
    fill='currentColor'
    viewBox='0 0 22.76 22.76'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.38 22.76a11.38 11.38 0 1 1 8.05-3.33 11.3 11.3 0 0 1-8.05 3.33zM8.1 3a.98.98 0 0 0 0 1.96h.78v5.06l-3.13 5.86a2.48 2.48 0 0 0 2.2 3.65h6.9a2.48 2.48 0 0 0 2.18-3.65l-3.13-5.86V4.96h.76a.98.98 0 1 0 0-1.96zm6.75 15.86h-6.9a1.8 1.8 0 0 1-1.6-2.66l3.2-6V4.95h3.68v5.23l3.21 6.01a1.8 1.8 0 0 1-1.6 2.66zm-5.59-6.62l-2.32 4.34a1.13 1.13 0 0 0 1 1.67h6.9a1.13 1.13 0 0 0 1-1.67l-2.32-4.34H9.26zm2.05-2.64a.8.8 0 1 0 .76.58.8.8 0 0 0-.76-.58zm1.08-3.47a.66.66 0 1 0 0 1.32.68.68 0 0 0 .19-.02.66.66 0 0 0-.18-1.3zm.64 9.92a1.27 1.27 0 0 1-1.22-.92 1.27 1.27 0 0 1 1.22-1.61 1.27 1.27 0 0 1 0 2.53z'
    />
  </svg>

export const User = () =>
  <svg
    fill='currentColor'
    viewBox='0 0 41.6 34.5'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M20.8 0a20.8 20.8 0 0 0-16 34c.4-3.7 4-6.8 9-8.2a10 10 0 0 0 13.7.1c5.2 1.6 8.7 4.9 8.9 8.6A20.8 20.8 0 0 0 20.8 0zm0 26.1a7.4 7.4 0 0 1-3.7-1 9.4 9.4 0 0 1-4.5-8.2 8.8 8.8 0 0 1 8.2-9.2 8.8 8.8 0 0 1 8.2 9.2 9.4 9.4 0 0 1-4.7 8.3 7.4 7.4 0 0 1-3.5 1z' />
  </svg>

export const Logout = () =>
  <svg
    fill='currentColor'
    viewBox='0 0 20 20'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M10 20a10 10 0 1110-10 10.01 10.01 0 01-10 10zM5 4.04a.13.13 0 00-.03 0l-.03.01a.53.53 0 00-.07.02.54.54 0 00-.16.07.07.07 0 01-.02 0 .06.06 0 00-.02.01v.02a.54.54 0 00-.15.17.12.12 0 00-.01.03v.02a.45.45 0 00-.04.12.1.1 0 000 .03.17.17 0 010 .02.06.06 0 010 .02.05.05 0 000 .01v10.93a.55.55 0 00.44.53l5.46 1.1a.47.47 0 00.1 0 .55.55 0 00.35-.12.55.55 0 00.2-.42v-.55h2.72a.55.55 0 00.55-.54v-3.28a.55.55 0 10-1.1 0v2.73h-2.18V6.23a.55.55 0 00-.39-.52l-1.9-.57h4.47v2.73a.55.55 0 001.1 0V4.6a.55.55 0 00-.55-.55zm7.65 5.47a.55.55 0 100 1.09h3.05l-.7.7a.55.55 0 10.77.78l1.63-1.64a.55.55 0 00.12-.18.55.55 0 000-.42.56.56 0 00-.12-.17l-1.63-1.64a.55.55 0 10-.78.77l.71.7z' />
  </svg>

export const DownloadArrow = () =>
  <svg
    fill='currentColor'
    height='14'
    preserveAspectRatio='none'
    viewBox='0 0 296 296'
    width='14'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M148.382 233.171l95.388-95.388-31.8-31.8-42.395 42.394V0h-42.39v148.382L84.79 105.988l-31.8 31.8z' />
    <path d='M0 254.369h296.763v42.394H0z' />
  </svg>

export const ApiAccess = () =>
  <svg
    fill='currentColor'
    height='84.943'
    viewBox='0 0 80.066 84.943'
    width='80.066'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g
      data-name='API ICON'
      transform='translate(-0.009)'
    >
      <path
        d='M39.884,84.943a42.825,42.825,0,0,1-6.9-.581,3.993,3.993,0,0,1-3.019-2.954l-2.074-9.473a32.612,32.612,0,0,1-7.3-4.231l-9.234,2.953a3.977,3.977,0,0,1-1.2.186A3.706,3.706,0,0,1,7.288,69.53,43.8,43.8,0,0,1,3.62,64.337l-.777-1.344A41.456,41.456,0,0,1,.226,57.3a3.751,3.751,0,0,1,1.053-4.082l7.177-6.537a32.166,32.166,0,0,1,0-8.428L1.279,31.721A3.761,3.761,0,0,1,.226,27.64a41.558,41.558,0,0,1,2.617-5.691l.775-1.344a43.245,43.245,0,0,1,3.67-5.185A3.687,3.687,0,0,1,10.147,14.1a3.969,3.969,0,0,1,1.208.189l9.234,2.947a31.877,31.877,0,0,1,7.3-4.226l2.074-9.473A3.757,3.757,0,0,1,32.981.582a42.983,42.983,0,0,1,14.1,0A3.757,3.757,0,0,1,50.1,3.539l2.074,9.473a35.306,35.306,0,0,1,7.3,4.226l9.24-2.947a3.937,3.937,0,0,1,1.2-.189,3.721,3.721,0,0,1,2.863,1.318,43.215,43.215,0,0,1,3.667,5.185l.779,1.344a42.134,42.134,0,0,1,2.6,5.691,3.744,3.744,0,0,1-1.045,4.081L71.6,38.257a31.657,31.657,0,0,1,0,8.428l7.184,6.537A3.746,3.746,0,0,1,79.833,57.3a42.136,42.136,0,0,1-2.6,5.691l-.779,1.344a43.992,43.992,0,0,1-3.667,5.193,3.74,3.74,0,0,1-2.869,1.314,3.944,3.944,0,0,1-1.2-.186l-9.24-2.953a36.254,36.254,0,0,1-7.3,4.231L50.1,81.409a3.993,3.993,0,0,1-3.02,2.954A43.428,43.428,0,0,1,39.884,84.943Zm.148-67.974a25.424,25.424,0,1,0,9.927,2A25.341,25.341,0,0,0,40.031,16.969Z'
        data-name='Subtraction 6'
        fill='#fff'
        transform='translate(0.01 0)'
      />
      <path
        d='M26.619,106.7l-9.945-9.946a2.486,2.486,0,1,0-3.516,3.516l5.707,5.7H2.486a2.486,2.486,0,0,0,0,4.973H18.865l-5.7,5.7a2.486,2.486,0,0,0,3.516,3.516l9.945-9.946A2.489,2.489,0,0,0,26.619,106.7Z'
        fill='#fff'
        transform='translate(29.174 -74.615)'
      />
      <path
        d='M.729,106.7l9.945-9.946a2.486,2.486,0,1,1,3.516,3.516l-5.707,5.7H24.862a2.486,2.486,0,0,1,0,4.973H8.483l5.7,5.7a2.486,2.486,0,0,1-3.516,3.516L.724,110.213A2.489,2.489,0,0,1,.729,106.7Z'
        data-name='arrow-right-to-bracket-solid'
        fill='#fff'
        transform='translate(23.565 -57.355)'
      />
    </g>
  </svg>

export const ScheduleManagement = () =>
  <svg
    fill='none'
    height='50'
    viewBox='0 0 39 39'
    width='50'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M33.7086 2.50204H31.9857L31.4935 4.30707C31.0831 5.94779 29.4833 7.17851 27.8426 7.17851C26.9401 7.17851 26.0788 6.80938 25.5863 6.11202C25.0529 5.41469 24.889 4.4713 25.135 3.56875L25.4223 2.50226L19.884 2.50198L19.3919 4.307C18.9406 5.94772 17.3817 7.17844 15.7001 7.17844C14.7976 7.17844 13.9772 6.80931 13.4438 6.11195C12.9105 5.41459 12.7465 4.47123 12.9926 3.56869L13.2799 2.5022H11.4748C8.72638 2.5022 5.978 4.63539 5.28063 7.38384L0.193587 26.1307C-0.216746 27.6075 0.0296252 29.0843 0.890918 30.1508C1.71128 31.2173 2.98295 31.8327 4.41878 31.8327H6.9211V32.9404C6.9211 35.8531 9.30035 38.232 12.2127 38.232H33.7081C36.6208 38.232 38.9997 35.8528 38.9997 32.9404L39 7.79413C39 4.88145 36.6209 2.50204 33.7086 2.50204ZM4.46014 28.6328C4.13193 28.6328 3.7219 28.5507 3.47555 28.2225C3.22947 27.9352 3.18826 27.4842 3.35251 26.9918L7.53679 11.3215H33.0522L29.0731 26.1713C28.704 27.525 27.2681 28.6737 25.9556 28.6737L4.46024 28.6739L4.46014 28.6328ZM35.8007 32.9399C35.8007 34.0885 34.8572 35.0319 33.7086 35.0319L12.2543 35.0322C11.1057 35.0322 10.1623 34.0888 10.1623 32.9402V31.8325H25.9556C28.7041 31.8325 31.4524 29.6993 32.1498 26.9509L35.8007 13.3727L35.8007 32.9399Z'
      fill='#3E2B56'
    />
    <path
      d='M15.7001 5.70171C16.6847 5.70171 17.6691 4.92223 17.9151 3.93793L18.4894 1.76378C18.7355 0.779191 18.1612 0 17.2178 0C16.2332 0 15.2489 0.779484 15.0028 1.76378L14.4282 3.93793C14.1821 4.88135 14.7564 5.70171 15.7001 5.70171Z'
      fill='#907DBA'
    />
    <path
      d='M27.8425 5.70171C28.8271 5.70171 29.8115 4.92223 30.0575 3.93793L30.6318 1.76378C30.8779 0.779191 30.3036 0 29.3602 0C28.3756 0 27.3912 0.779484 27.1452 1.76378L26.53 3.93793C26.2836 4.88135 26.8579 5.70171 27.8425 5.70171Z'
      fill='#907DBA'
    />
    <path
      d='M19.6027 21.1957H15.7879C15.5418 21.1957 15.2545 21.4008 15.1726 21.6469L14.4344 24.4362C14.3523 24.6823 14.5165 24.8875 14.7626 24.8875H18.5775C18.8236 24.8875 19.1108 24.6823 19.1927 24.4362L19.9309 21.6469C20.0128 21.4008 19.8488 21.1957 19.6027 21.1957Z'
      fill='#62C6C4'
    />
    <path
      d='M12.8696 21.1957H9.05472C8.80863 21.1957 8.52135 21.4008 8.43951 21.6469L7.70127 24.4362C7.61915 24.6823 7.78339 24.8875 8.02948 24.8875H11.8443C12.0904 24.8875 12.3777 24.6823 12.4596 24.4362L13.1978 21.6469C13.2796 21.4008 13.1566 21.1957 12.8696 21.1957Z'
      fill='#62C6C4'
    />
    <path
      d='M26.3246 20.9619H22.5098C22.2637 20.9619 21.9764 21.167 21.8946 21.4131L21.1557 24.2027C21.0736 24.4488 21.2379 24.654 21.484 24.654H25.2988C25.5449 24.654 25.8322 24.4488 25.914 24.2027L26.6523 21.4134C26.7347 21.167 26.5707 20.9619 26.3246 20.9619Z'
      fill='#62C6C4'
    />
    <path
      d='M19.6027 15.2609H15.7879C15.5418 15.2609 15.2545 15.466 15.1727 15.7121L14.4344 18.5014C14.3523 18.7475 14.5165 18.9527 14.7626 18.9527H18.5775C18.8236 18.9527 19.1108 18.7475 19.1927 18.5014L19.9309 15.7121C20.0131 15.466 19.89 15.2609 19.6027 15.2609Z'
      fill='#62C6C4'
    />
    <path
      d='M13.6679 15.2609H9.85308C9.60699 15.2609 9.31971 15.466 9.23787 15.7121L8.49963 18.5014C8.4175 18.7475 8.58175 18.9527 8.82784 18.9527H12.6427C12.8888 18.9527 13.1761 18.7475 13.2579 18.5014L13.9962 15.7121C14.078 15.466 13.914 15.2609 13.6679 15.2609Z'
      fill='#62C6C4'
    />
    <path
      d='M21.5486 18.9527H25.3637C25.6098 18.9527 25.8971 18.7475 25.9789 18.5014L26.7172 15.7121C26.7993 15.466 26.635 15.2609 26.389 15.2609H22.5741C22.328 15.2609 22.0407 15.466 21.9589 15.7121L21.2206 18.5014C21.1385 18.7066 21.2616 18.9527 21.5486 18.9527Z'
      fill='#62C6C4'
    />
  </svg>

export const HeartBroken = ({ size }: IconInterface) =>
  <svg
    fill='currentColor'
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.7313 6.34097C9.74446 5.4571 8.42162 4.97509 7.05379 5.00099C5.68596 5.02689 4.38518 5.55857 3.43761 6.47907C2.49004 7.39957 1.9733 8.63348 2.00106 9.90936C2.02883 11.1852 2.59883 12.3986 3.58566 13.2825L11.5325 20.802C11.5987 20.8647 11.6776 20.9145 11.7646 20.9485C11.8516 20.9825 11.945 21 12.0393 21C12.1336 21 12.227 20.9825 12.3141 20.9485C12.4011 20.9145 12.48 20.8647 12.5462 20.802L20.4867 13.2825C21.4548 12.3805 21.9992 11.1569 22 9.88058C22.0008 8.60431 21.4581 7.38001 20.4912 6.477C19.5243 5.57399 18.2124 5.06624 16.8442 5.06547C15.4759 5.06469 14.1634 5.57094 13.1953 6.47285L11.0256 8.38053L13.3731 10.5719C13.4393 10.6335 13.4917 10.7067 13.5275 10.7872C13.5633 10.8678 13.5818 10.9541 13.5818 11.0413C13.5818 11.1285 13.5633 11.2149 13.5275 11.2954C13.4917 11.376 13.4393 11.4492 13.3731 11.5108L11.5334 13.2269C11.4672 13.2885 11.3887 13.3373 11.3023 13.3706C11.2159 13.4039 11.1234 13.421 11.0299 13.4209C10.9364 13.4208 10.8439 13.4036 10.7576 13.3702C10.6712 13.3367 10.5928 13.2878 10.5268 13.2261C10.4607 13.1643 10.4084 13.0911 10.3727 13.0105C10.337 12.93 10.3187 12.8436 10.3188 12.7564C10.3188 12.6692 10.3373 12.5829 10.3732 12.5024C10.409 12.4219 10.4615 12.3487 10.5277 12.2871L11.8615 11.043L9.50509 8.83838C9.43735 8.77525 9.38398 8.70001 9.34816 8.61718C9.31235 8.53435 9.29483 8.44563 9.29665 8.35633C9.29848 8.26703 9.31961 8.17899 9.35879 8.0975C9.39797 8.016 9.45438 7.94272 9.52465 7.88205L10.7295 6.82204C10.7645 6.79104 10.7923 6.75374 10.8114 6.71238C10.8304 6.67103 10.8402 6.6265 10.8402 6.5815C10.8402 6.5365 10.8304 6.49197 10.8114 6.45062C10.7923 6.40927 10.7645 6.37196 10.7295 6.34097H10.7313Z'
    />
  </svg>

export const InProgressCircle = () =>
  <svg
    fill='none'
    height='18'
    viewBox='0 0 18 18'
    width='18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M9.25 15.05C12.4533 15.05 15.05 12.4533 15.05 9.25C15.05 6.04675 12.4533 3.45 9.25 3.45C6.04675 3.45 3.45 6.04675 3.45 9.25C3.45 12.4533 6.04675 15.05 9.25 15.05ZM9.25 16.5C13.2541 16.5 16.5 13.2541 16.5 9.25C16.5 5.24594 13.2541 2 9.25 2C5.24594 2 2 5.24594 2 9.25C2 13.2541 5.24594 16.5 9.25 16.5Z'
      fill='#7E57C5'
      fillOpacity='0.3'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M9.25 14.35C12.0667 14.35 14.35 12.0667 14.35 9.25C14.35 6.43335 12.0667 4.15 9.25 4.15C6.43335 4.15 4.15 6.43335 4.15 9.25C4.15 12.0667 6.43335 14.35 9.25 14.35ZM17.2 9.25C17.2 13.6407 13.6407 17.2 9.25 17.2C4.85934 17.2 1.3 13.6407 1.3 9.25C1.3 4.85934 4.85934 1.3 9.25 1.3C13.6407 1.3 17.2 4.85934 17.2 9.25ZM15.05 9.25C15.05 12.4533 12.4533 15.05 9.25 15.05C6.04675 15.05 3.45 12.4533 3.45 9.25C3.45 6.04675 6.04675 3.45 9.25 3.45C12.4533 3.45 15.05 6.04675 15.05 9.25ZM16.5 9.25C16.5 13.2541 13.2541 16.5 9.25 16.5C5.24594 16.5 2 13.2541 2 9.25C2 5.24594 5.24594 2 9.25 2C13.2541 2 16.5 5.24594 16.5 9.25Z'
      fill='#7E57C5'
      fillOpacity='0.3'
      fillRule='evenodd'
    />
    <path
      d='M9.25 15.05C12.4533 15.05 15.05 12.4533 15.05 9.25C15.05 6.04675 12.4533 3.45 9.25 3.45V2C13.2541 2 16.5 5.24594 16.5 9.25C16.5 13.2541 13.2541 16.5 9.25 16.5V15.05Z'
      fill='#7E57C5'
    />
    <path
      clipRule='evenodd'
      d='M8.55 14.35H9.25C12.0667 14.35 14.35 12.0667 14.35 9.25C14.35 6.43335 12.0667 4.15 9.25 4.15H8.55V1.3H9.25C13.6407 1.3 17.2 4.85934 17.2 9.25C17.2 13.6407 13.6407 17.2 9.25 17.2H8.55V14.35ZM9.25 15.05C12.4533 15.05 15.05 12.4533 15.05 9.25C15.05 6.04675 12.4533 3.45 9.25 3.45V2C9.48614 2 9.71965 2.01129 9.95 2.03336C13.6256 2.3855 16.5 5.48208 16.5 9.25C16.5 13.0179 13.6256 16.1145 9.95 16.4666C9.71965 16.4887 9.48614 16.5 9.25 16.5V15.05Z'
      fill='#7E57C5'
      fillRule='evenodd'
    />
  </svg>

export const BsSpeedometerSlow = ({ size }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.0001 6.74365C11.8256 6.74365 11.6584 6.81294 11.5351 6.93626C11.4117 7.05959 11.3424 7.22686 11.3424 7.40127V9.37411C11.3424 9.54852 11.4117 9.71579 11.5351 9.83911C11.6584 9.96244 11.8256 10.0317 12.0001 10.0317C12.1745 10.0317 12.3417 9.96244 12.4651 9.83911C12.5884 9.71579 12.6577 9.54852 12.6577 9.37411V7.40127C12.6577 7.22686 12.5884 7.05959 12.4651 6.93626C12.3417 6.81294 12.1745 6.74365 12.0001 6.74365ZM17.6134 9.02163C17.4901 8.89835 17.3228 8.82909 17.1485 8.82909C16.9741 8.82909 16.8069 8.89835 16.6835 9.02163L15.4801 10.2237C15.419 10.2849 15.3705 10.3575 15.3374 10.4374C15.3043 10.5173 15.2873 10.6029 15.2873 10.6893C15.2873 10.7758 15.3043 10.8614 15.3374 10.9413C15.3705 11.0212 15.419 11.0938 15.4801 11.1549C15.5413 11.2161 15.6138 11.2646 15.6937 11.2977C15.7736 11.3308 15.8592 11.3478 15.9457 11.3478C16.0322 11.3478 16.1178 11.3308 16.1977 11.2977C16.2776 11.2646 16.3502 11.2161 16.4113 11.1549L17.6134 9.9515C17.7367 9.82818 17.8059 9.66094 17.8059 9.48656C17.8059 9.31219 17.7367 9.14495 17.6134 9.02163ZM19.8914 14.635C19.8914 14.4606 19.8221 14.2934 19.6987 14.17C19.5754 14.0467 19.4082 13.9774 19.2337 13.9774H17.1478C16.9734 13.9774 16.8061 14.0467 16.6828 14.17C16.5595 14.2934 16.4902 14.4606 16.4902 14.635C16.4902 14.8094 16.5595 14.9767 16.6828 15.1C16.8061 15.2234 16.9734 15.2926 17.1478 15.2926H19.2337C19.4082 15.2926 19.5754 15.2234 19.6987 15.1C19.8221 14.9767 19.8914 14.8094 19.8914 14.635ZM7.3968 14.635C7.3968 14.4606 7.32751 14.2934 7.20419 14.17C7.08086 14.0467 6.9136 13.9774 6.73919 13.9774H4.76636C4.59195 13.9774 4.42469 14.0467 4.30136 14.17C4.17804 14.2934 4.10875 14.4606 4.10875 14.635C4.10875 14.8094 4.17804 14.9767 4.30136 15.1C4.42469 15.2234 4.59195 15.2926 4.76636 15.2926H6.73919C6.9136 15.2926 7.08086 15.2234 7.20419 15.1C7.32751 14.9767 7.3968 14.8094 7.3968 14.635ZM6.40512 9.05057C6.49623 8.95993 6.61812 8.9069 6.74654 8.90202C6.87497 8.89715 7.00052 8.94079 7.09824 9.02426L12.5958 13.7275C12.7239 13.8354 12.828 13.9691 12.9012 14.1197C12.9744 14.2704 13.0151 14.4347 13.0208 14.6021C13.0265 14.7695 12.997 14.9362 12.9342 15.0915C12.8714 15.2468 12.7768 15.3871 12.6563 15.5035C12.5359 15.6199 12.3923 15.7097 12.235 15.7671C12.0776 15.8246 11.91 15.8483 11.7429 15.8369C11.5758 15.8254 11.4129 15.779 11.2649 15.7007C11.1168 15.6223 10.9869 15.5138 10.8834 15.3821L6.36698 9.73054C6.28841 9.63218 6.24885 9.5083 6.25589 9.38261C6.26293 9.25691 6.31606 9.13822 6.40512 9.04925V9.05057Z'
      fill='currentColor'
      stroke='currentColor'
      strokeLinejoin='round'
      strokeWidth='0.478262'
    />
    <path
      clipRule='evenodd'
      d='M1.00001 14.7532C1.00144 13.1524 1.35224 11.5712 2.02792 10.12C2.70359 8.66879 3.68786 7.38255 4.912 6.35106C6.13614 5.31957 7.57066 4.56768 9.11541 4.1479C10.6602 3.72812 12.2779 3.65055 13.8558 3.92061C15.4336 4.19067 16.9335 4.80185 18.2507 5.71149C19.5679 6.62113 20.6707 7.8073 21.4821 9.1872C22.2935 10.5671 22.794 12.1075 22.9486 13.7008C23.1032 15.2941 22.9081 16.9019 22.3771 18.4121C21.7694 20.135 19.8403 20.6149 18.3456 20.1309C16.5499 19.5492 14.0281 18.8782 12 18.8782C9.97326 18.8782 7.44876 19.5492 5.65438 20.1309C4.15976 20.6149 2.23063 20.135 1.62288 18.4121C1.2092 17.2366 0.998571 15.9993 1.00001 14.7532ZM12 5.12808C10.4605 5.12768 8.94339 5.49657 7.57596 6.20379C6.20853 6.91102 5.03068 7.93594 4.14128 9.19253C3.25189 10.4491 2.67688 11.9007 2.46453 13.4255C2.25218 14.9503 2.40867 16.5038 2.92088 17.9556C3.20001 18.7462 4.19001 19.1601 5.23088 18.8218C7.04588 18.2361 9.74226 17.5032 12 17.5032C14.2578 17.5032 16.9555 18.2347 18.7691 18.8232C19.81 19.1601 20.8 18.7462 21.0791 17.9556C21.5913 16.5038 21.7478 14.9503 21.5355 13.4255C21.3231 11.9007 20.7481 10.4491 19.8587 9.19253C18.9693 7.93594 17.7915 6.91102 16.4241 6.20379C15.0566 5.49657 13.5395 5.12768 12 5.12808Z'
      fill='currentColor'
      fillRule='evenodd'
      stroke='currentColor'
      strokeWidth='0.38261'
    />
  </svg>

export const FiRerun = ({ size }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 14 14'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M0.583008 1.75C0.260841 1.75 -0.00032568 2.01117 -0.00032568 2.33333V5.25C-0.00032568 5.57217 0.260841 5.83333 0.583008 5.83333H3.49967C3.82184 5.83333 4.08301 5.57217 4.08301 5.25C4.08301 4.92783 3.82184 4.66667 3.49967 4.66667H1.16634V2.33333C1.16634 2.01117 0.905174 1.75 0.583008 1.75Z'
      fill='#797979'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M6.30846 1.91753C7.40588 1.76122 8.52415 1.9673 9.49478 2.50472C10.4654 3.04214 11.2358 3.88177 11.6898 4.8971C12.1439 5.91242 12.257 7.04843 12.0122 8.13394C11.7673 9.21944 11.1778 10.1956 10.3324 10.9154C9.48694 11.6352 8.43145 12.0595 7.32494 12.1245C6.21844 12.1896 5.12087 11.8917 4.19763 11.2758C3.27439 10.6599 2.5755 9.75941 2.20627 8.70998C2.08871 8.37584 1.72365 8.20066 1.39089 8.31871C1.05813 8.43676 0.88368 8.80334 1.00124 9.13748C1.46277 10.4493 2.33639 11.5749 3.49044 12.3447C4.64449 13.1146 6.01645 13.4869 7.39958 13.4057C8.78271 13.3244 10.1021 12.794 11.1589 11.8943C12.2156 10.9946 12.9526 9.77431 13.2586 8.41743C13.5647 7.06054 13.4233 5.64053 12.8557 4.37137C12.2881 3.10222 11.3252 2.05267 10.1119 1.3809C8.89859 0.709133 7.50075 0.45153 6.12898 0.646912C4.7605 0.841828 3.49193 1.47703 2.51349 2.4571L0.200769 4.60659C-0.056159 4.84954 -0.068305 5.25564 0.17364 5.51363C0.415586 5.77163 0.820004 5.78383 1.07693 5.54088L3.39654 3.38488C3.40125 3.38043 3.40588 3.37591 3.41045 3.37132C4.19396 2.58406 5.21105 2.07383 6.30846 1.91753Z'
      fill='#797979'
      fillRule='evenodd'
    />
    <path
      d='M9.15658 7.60773L6.37291 9.28256C6.13667 9.42455 5.8335 9.25262 5.8335 8.96638V5.6167C5.8335 5.33091 6.13623 5.15852 6.37291 5.30097L9.15658 6.9758C9.21032 7.00762 9.25499 7.0536 9.28606 7.10909C9.31713 7.16458 9.3335 7.2276 9.3335 7.29176C9.3335 7.35593 9.31713 7.41895 9.28606 7.47444C9.25499 7.52993 9.21032 7.57591 9.15658 7.60773Z'
      fill='#797979'
    />
  </svg>

export const StateRerunCircle = () =>
  <svg
    fill='none'
    height='18'
    viewBox='0 0 19 18'
    width='19'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M9.51152 16.2C11.4211 16.2 13.2524 15.4414 14.6027 14.0912C15.953 12.7409 16.7115 10.9095 16.7115 8.99999C16.7115 7.09043 15.953 5.25908 14.6027 3.90882C13.2524 2.55856 11.4211 1.79999 9.51152 1.79999C7.60197 1.79999 5.77062 2.55856 4.42035 3.90882C3.07009 5.25908 2.31152 7.09043 2.31152 8.99999C2.31152 10.9095 3.07009 12.7409 4.42035 14.0912C5.77062 15.4414 7.60197 16.2 9.51152 16.2Z'
      fillRule='evenodd'
      stroke='#36B15B'
    />
    <mask
      height='144'
      maskUnits='userSpaceOnUse'
      style={{ maskType: 'alpha' }}
      width='36'
      x='1'
      y='-32'
    >
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-31.0485'
        y2='2.55636'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-28.2714'
        y2='5.33352'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-25.4942'
        y2='8.11068'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-22.7168'
        y2='10.8881'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-19.9393'
        y2='13.6656'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-17.1621'
        y2='16.4428'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-14.385'
        y2='19.2199'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-11.6078'
        y2='21.9971'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-8.83065'
        y2='24.7743'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-6.05282'
        y2='27.5521'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-3.27566'
        y2='30.3292'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='-0.498558'
        y2='33.1063'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='2.2786'
        y2='35.8835'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='5.05576'
        y2='38.6607'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='7.83329'
        y2='41.4382'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='10.6104'
        y2='44.2153'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='13.3875'
        y2='46.9925'
      />
      <line
        stroke='white'
        x1='35.649'
        x2='2.04406'
        y1='16.1647'
        y2='49.7696'
      />
    </mask>
    <g mask='url(#mask0_4134_10227)'>
      <path
        clipRule='evenodd'
        d='M9.51152 16.2C11.4211 16.2 13.2524 15.4414 14.6027 14.0912C15.953 12.7409 16.7115 10.9095 16.7115 8.99999C16.7115 7.09043 15.953 5.25908 14.6027 3.90882C13.2524 2.55856 11.4211 1.79999 9.51152 1.79999C7.60196 1.79999 5.77062 2.55856 4.42035 3.90882C3.07009 5.25908 2.31152 7.09043 2.31152 8.99999C2.31152 10.9095 3.07009 12.7409 4.42035 14.0912C5.77062 15.4414 7.60196 16.2 9.51152 16.2Z'
        fill='#36B15B'
        fillRule='evenodd'
      />
    </g>
  </svg>

export const StateRerunDot = () =>
  <svg
    fill='none'
    height='18'
    viewBox='0 0 19 18'
    width='19'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.7377 13.7376C12.4812 14.9941 10.777 15.7 9.00005 15.7C7.2231 15.7 5.51893 14.9941 4.26243 13.7376C3.00594 12.4811 2.30005 10.7769 2.30005 8.99999C2.30005 7.22304 3.00594 5.51887 4.26243 4.26237C5.51893 3.00588 7.2231 2.29999 9.00005 2.29999C10.777 2.29999 12.4812 3.00588 13.7377 4.26237C14.9942 5.51887 15.7001 7.22304 15.7001 8.99999C15.7001 10.7769 14.9942 12.4811 13.7377 13.7376Z'
      fill='#36B15B'
      fillOpacity='0.1'
      stroke='#36B15B'
    />
    <mask
      height='144'
      maskUnits='userSpaceOnUse'
      style={{ maskType: 'alpha' }}
      width='35'
      x='1'
      y='-32'
    >
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-31.0485'
        y2='2.55636'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-28.2714'
        y2='5.33351'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-25.4942'
        y2='8.11066'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-22.7168'
        y2='10.8881'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-19.9393'
        y2='13.6656'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-17.1621'
        y2='16.4428'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-14.385'
        y2='19.2199'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-11.6078'
        y2='21.9971'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-8.83066'
        y2='24.7742'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-6.05283'
        y2='27.5521'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-3.27568'
        y2='30.3292'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='-0.49853'
        y2='33.1064'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53197'
        y1='2.27862'
        y2='35.8835'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='5.05577'
        y2='38.6607'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53197'
        y1='7.83326'
        y2='41.4382'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='10.6104'
        y2='44.2153'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='13.3876'
        y2='46.9925'
      />
      <line
        stroke='white'
        x1='35.1369'
        x2='1.53198'
        y1='16.1647'
        y2='49.7696'
      />
    </mask>
    <g mask='url(#mask0_6679_12753)'>
      <path
        clipRule='evenodd'
        d='M9.00005 16.2C10.9096 16.2 12.741 15.4414 14.0912 14.0912C15.4415 12.7409 16.2001 10.9095 16.2001 8.99999C16.2001 7.09043 15.4415 5.25908 14.0912 3.90882C12.741 2.55856 10.9096 1.79999 9.00005 1.79999C7.09049 1.79999 5.25914 2.55856 3.90888 3.90882C2.55862 5.25908 1.80005 7.09043 1.80005 8.99999C1.80005 10.9095 2.55862 12.7409 3.90888 14.0912C5.25914 15.4414 7.09049 16.2 9.00005 16.2Z'
        fill='#36B15B'
        fillRule='evenodd'
      />
    </g>
    <path
      d='M12.6898 8.1844L12.6899 8.18445L12.6959 8.1782C12.9509 7.91416 13.092 7.56051 13.0888 7.19344C13.0856 6.82636 12.9384 6.47523 12.6788 6.21565C12.4193 5.95608 12.0681 5.80885 11.7011 5.80566C11.334 5.80247 10.9803 5.94358 10.7163 6.1986L10.7162 6.19855L10.7101 6.20469L8.09995 8.81484L7.28981 8.00469L7.28986 8.00464L7.28361 7.9986C7.01956 7.74358 6.66592 7.60247 6.29885 7.60566C5.93177 7.60885 5.58063 7.75608 5.32106 8.01565C5.06149 8.27523 4.91425 8.62636 4.91106 8.99344C4.90787 9.36051 5.04899 9.71416 5.30401 9.9782L5.30395 9.97825L5.3101 9.9844L7.1101 11.7844L7.11015 11.7845C7.37269 12.0469 7.72872 12.1944 8.09995 12.1944C8.47118 12.1944 8.82721 12.0469 9.08975 11.7845L9.08981 11.7844L12.6898 8.1844Z'
      fill='var(--background)'
      stroke='#36B15B'
    />
  </svg>

export const Cross = ({ size }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 12 12'
    width='12'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 6L8 8M4 8L6 6L4 8ZM6 6L8 4L6 6ZM6 6L4 4L6 6Z'
      stroke='#797979'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
  </svg>

export const TbPlayerPlayFilled = () =>
  <svg
    fill='none'
    height='15'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='15'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path
      d='M6 4v16a1 1 0 0 0 1.524 .852l13 -8a1 1 0 0 0 0 -1.704l-13 -8a1 1 0 0 0 -1.524 .852z'
      fill='currentColor'
      strokeWidth='0'
    />
  </svg>

export const Suites = ({ size }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M1.10539 6.57095C1.10539 5.15104 2.25644 4 3.67635 4H10.0321C10.2743 4 10.5065 4.09618 10.6777 4.26739L12.621 6.21071H16.1116C17.5315 6.21071 18.6826 7.36175 18.6826 8.78166V10.6321H20.2554C21.5998 10.6321 22.4375 12.0905 21.7601 13.2518M21.7601 13.2518L19.2584 17.5403C19.2584 17.5404 19.2584 17.5403 19.2584 17.5403C18.9833 18.0119 18.5894 18.4032 18.116 18.6751C17.6426 18.947 17.1062 19.0901 16.5603 19.0901H2.74457C1.50822 19.0901 0.700432 17.8567 1.10541 16.7553L1.10539 6.57095H2.01832L2.93124 6.57103L2.93125 13.571L3.74161 12.1818C4.01669 11.7103 4.41057 11.319 4.88398 11.0471C5.35739 10.7752 5.8938 10.6321 6.43974 10.6321H16.8567V8.78166C16.8567 8.37014 16.5231 8.03655 16.1116 8.03655H12.2429C12.0007 8.03655 11.7685 7.94037 11.5973 7.76916L9.654 5.82585H3.67635C3.26482 5.82585 2.93124 6.15951 2.93124 6.57103L2.01832 6.57095H1.10539M2.89065 17.2642H16.5603C16.7871 17.2642 17.01 17.2048 17.2066 17.0918C17.4033 16.9789 17.567 16.8163 17.6812 16.6204L20.1093 12.458H6.43974C6.21291 12.458 5.99005 12.5174 5.79336 12.6304C5.59667 12.7434 5.43302 12.9059 5.31873 13.1018L2.89065 17.2642Z'
      fill='#55595C'
      fillRule='evenodd'
    />
  </svg>

export const Models = ({ size }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M13.9955 2.29361C14.8677 1.88864 15.877 1.90326 16.7371 2.33334L22.4933 5.21142C22.8038 5.3667 23 5.68411 23 6.03132L23 13.2394C23 14.4077 22.3548 15.4806 21.3229 16.0283L9.20219 22.4616C8.91887 22.612 8.57756 22.6033 8.30222 22.4388L2.53777 18.9941C1.584 18.4242 1 17.3948 1 16.2838V8.91227C1 8.55547 1.20703 8.2311 1.53065 8.08084L13.9955 2.29361ZM15.9172 3.97312C15.5565 3.79277 15.1333 3.78664 14.7675 3.95646L3.87643 9.01303L8.80144 11.9479L20.0709 6.04994L15.9172 3.97312ZM21.1667 7.54568L9.6891 13.5525L9.6891 20.1276L20.4634 14.4089C20.8961 14.1792 21.1667 13.7293 21.1667 13.2394L21.1667 7.54568ZM7.85577 20.0363L7.85577 13.5185L2.83333 10.5256L2.83333 16.2838C2.83333 16.7497 3.07824 17.1813 3.4782 17.4204L7.85577 20.0363ZM16.0485 5.26297C15.5062 5.26297 15.0615 5.34469 14.7434 5.45581C14.5857 5.51087 14.4491 5.57662 14.3457 5.65058C14.2943 5.68735 14.2423 5.73236 14.2005 5.78686C14.1606 5.83891 14.1125 5.92293 14.1125 6.03122C14.1125 6.14105 14.1621 6.22568 14.2023 6.27726C14.2445 6.33153 14.2969 6.37629 14.3486 6.41281C14.4527 6.48633 14.59 6.55185 14.7481 6.60679C15.0671 6.71766 15.5116 6.79948 16.0485 6.79948C16.5855 6.79948 17.0299 6.71766 17.349 6.60679C17.5071 6.55185 17.6444 6.48633 17.7484 6.41281C17.8001 6.37629 17.8525 6.33153 17.8948 6.27726C17.9349 6.22568 17.9845 6.14105 17.9845 6.03122C17.9845 5.9214 17.9349 5.83677 17.8948 5.78518C17.8525 5.73091 17.8001 5.68616 17.7484 5.64963C17.6444 5.57612 17.5071 5.5106 17.349 5.45566C17.0299 5.34479 16.5855 5.26297 16.0485 5.26297ZM9.32657 8.14397C8.78425 8.14397 8.33955 8.2257 8.0214 8.33682C7.86375 8.39188 7.72718 8.45763 7.62375 8.53159C7.57232 8.56837 7.52031 8.61337 7.47855 8.66788C7.43868 8.71992 7.39058 8.80394 7.39058 8.91224C7.39058 9.02206 7.44019 9.10669 7.48032 9.15828C7.52254 9.21255 7.57499 9.2573 7.62669 9.29383C7.73073 9.36734 7.86803 9.43286 8.02612 9.4878C8.34517 9.59867 8.78963 9.68048 9.32657 9.68048C9.86351 9.68048 10.308 9.59867 10.627 9.4878C10.7851 9.43286 10.9224 9.36734 11.0264 9.29383C11.0781 9.2573 11.1306 9.21255 11.1728 9.15828C11.2129 9.10669 11.2626 9.02206 11.2626 8.91224C11.2626 8.80241 11.2129 8.71778 11.1728 8.66619C11.1306 8.61192 11.0781 8.56717 11.0264 8.53065C10.9224 8.45713 10.7851 8.39161 10.627 8.33667C10.308 8.22579 9.86351 8.14397 9.32657 8.14397ZM12.6875 6.70351C12.1452 6.70351 11.7005 6.78523 11.3824 6.89635C11.2247 6.95141 11.0882 7.01716 10.9847 7.09112C10.9333 7.1279 10.8813 7.1729 10.8395 7.22741C10.7997 7.27945 10.7516 7.36348 10.7516 7.47177C10.7516 7.5816 10.8012 7.66622 10.8413 7.71781C10.8835 7.77208 10.936 7.81684 10.9877 7.85336C11.0917 7.92687 11.229 7.99239 11.3871 8.04733C11.7061 8.1582 12.1506 8.24002 12.6875 8.24002C13.2245 8.24002 13.6689 8.1582 13.988 8.04733C14.1461 7.99239 14.2834 7.92687 14.3874 7.85336C14.4391 7.81684 14.4916 7.77208 14.5338 7.71781C14.5739 7.66622 14.6235 7.5816 14.6235 7.47177C14.6235 7.36194 14.5739 7.27731 14.5338 7.22573C14.4916 7.17146 14.4391 7.1267 14.3874 7.09018C14.2834 7.01667 14.1461 6.95114 13.988 6.8962C13.6689 6.78533 13.2245 6.70351 12.6875 6.70351Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>

export const RerunIcon = ({ size }: IconInterface) =>
  <span
    className='flex'
    title='Rerun enabled'
  >
    <FiRerun
      aria-hidden
      size={size}
    />
  </span>

export const GripVertical = ({ size }: IconInterface) =>
  <svg
    fill='currentColor'
    height={size}
    stroke='currentColor'
    strokeWidth='0'
    viewBox='0 0 16 16'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'
    />
  </svg>

export const HiArrowSmUpDown = ({ size }: IconInterface) =>
  <svg
    aria-label='HiArrowSmUpDown'
    fill='currentColor'
    height={size}
    viewBox='0 0 12 12'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M5.54598 3.12898L3.32931 0.912312L3.32814 0.911138C3.22795 0.811544 3.08989 0.75 2.93746 0.75C2.86232 0.75 2.79067 0.764954 2.72533 0.79205C2.65997 0.819093 2.59874 0.85918 2.5456 0.912312L0.328938 3.12898C0.112522 3.3454 0.112522 3.69628 0.328938 3.91269C0.545353 4.12911 0.896232 4.12911 1.11265 3.91269L2.38329 2.64204V7.95417C2.38329 8.26023 2.6314 8.50834 2.93746 8.50834C3.24352 8.50834 3.49163 8.26023 3.49163 7.95417V2.64204L4.76227 3.91269C4.97869 4.12911 5.32957 4.12911 5.54598 3.91269C5.7624 3.69628 5.7624 3.3454 5.54598 3.12898Z'
      fill='currentColor'
      fillRule='evenodd'
    />
    <path
      d='M7.92496 3.52084V8.83296L6.65431 7.56232C6.4379 7.3459 6.08702 7.3459 5.8706 7.56232C5.65419 7.77873 5.65419 8.12961 5.8706 8.34603L8.08727 10.5627C8.19418 10.6696 8.3339 10.7237 8.47401 10.725L7.92496 8.83296L8.47913 10.725C8.48799 10.725 8.49685 10.7248 8.50571 10.7244C8.63855 10.718 8.76954 10.6641 8.87098 10.5627L11.0876 8.34603C11.3041 8.12961 11.3041 7.77873 11.0876 7.56232C10.8712 7.3459 10.5204 7.3459 10.3039 7.56232L9.03329 8.83296V3.52084C9.03329 3.21478 8.78518 2.96667 8.47913 2.96667C8.17307 2.96667 7.92496 3.21478 7.92496 3.52084Z'
      fill='currentColor'
    />
  </svg>

export const HiOutlineExport = ({ size }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='react-icons/hi/HiOutlineExport'>
      <path
        clipRule='evenodd'
        d='M2.87868 7.8201C3.44129 7.295 4.20435 7 5 7H8C8.55228 7 9 7.41787 9 7.93333C9 8.4488 8.55228 8.86667 8 8.86667H5C4.73478 8.86667 4.48043 8.965 4.29289 9.14003C4.10536 9.31507 4 9.55246 4 9.8V18.2C4 18.4475 4.10536 18.6849 4.29289 18.86C4.48043 19.035 4.73478 19.1333 5 19.1333H19C19.2652 19.1333 19.5196 19.035 19.7071 18.86C19.8946 18.6849 20 18.4475 20 18.2V9.8C20 9.55247 19.8946 9.31507 19.7071 9.14003C19.5196 8.965 19.2652 8.86667 19 8.86667H16C15.4477 8.86667 15 8.4488 15 7.93333C15 7.41787 15.4477 7 16 7H19C19.7957 7 20.5587 7.295 21.1213 7.8201C21.6839 8.3452 22 9.05739 22 9.8V18.2C22 18.9426 21.6839 19.6548 21.1213 20.1799C20.5587 20.705 19.7957 21 19 21H5C4.20435 21 3.44129 20.705 2.87868 20.1799C2.31607 19.6548 2 18.9426 2 18.2V9.8C2 9.05739 2.31607 8.3452 2.87868 7.8201Z'
        fill='currentColor'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M12 12C11.4477 12 11 11.5523 11 11L11 3.41421L9.70711 4.70711C9.31658 5.09763 8.68342 5.09763 8.29289 4.70711C7.90237 4.31658 7.90237 3.68342 8.29289 3.29289L11.2922 0.293607C11.2946 0.291191 11.297 0.288787 11.2994 0.286395C11.4792 0.109903 11.7254 0.00080146 11.997 4.16465e-06L12 3.49691e-07L12.003 4.16413e-06C12.1375 0.000398974 12.2657 0.0273469 12.3828 0.0758794C12.498 0.123571 12.6062 0.193742 12.7005 0.286395C12.703 0.288787 12.7054 0.29119 12.7078 0.293607L15.7071 3.29289C16.0976 3.68342 16.0976 4.31658 15.7071 4.70711C15.3166 5.09763 14.6834 5.09763 14.2929 4.70711L13 3.41421L13 11C13 11.5523 12.5523 12 12 12Z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </g>
  </svg>

export const State = ({ size }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 16 16'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_3086_32917)'>
      <path
        clipRule='evenodd'
        d='M14 4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2L4 2C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4L2 12C2 12.5304 2.21071 13.0391 2.58579 13.4142C2.96086 13.7893 3.46957 14 4 14L12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12L14 4ZM12.6667 5.33333L3.33333 5.33333L3.33333 12C3.33333 12.1768 3.40357 12.3464 3.5286 12.4714C3.65362 12.5964 3.82319 12.6667 4 12.6667L12 12.6667C12.1768 12.6667 12.3464 12.5964 12.4714 12.4714C12.5964 12.3464 12.6667 12.1768 12.6667 12L12.6667 5.33333Z'
        fill='var(--icon)'
        fillRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='clip0_3086_32917'>
        <rect
          height={size}
          width={size}
        />
      </clipPath>
    </defs>
  </svg>

export const Monitor = ({ size = '22.5' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 23 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_221_14844)'>
      <path
        clipRule='evenodd'
        d='M11.2498 23.25C9.0239 23.2512 6.84763 22.5921 4.99644 21.356C3.14525 20.1199 1.70235 18.3624 0.850359 16.306C0.229472 14.8074 -0.0572682 13.1991 0.00105158 11.592C0.0852485 5.61437 4.93745 0.789831 10.9257 0.750268C11.0336 0.747164 11.1416 0.745605 11.2498 0.745605C14.2347 0.745605 17.0973 1.93133 19.2079 4.04193C21.3185 6.15254 22.5042 9.01513 22.5042 12C22.5042 14.9848 21.3185 17.8474 19.2079 19.958C18.1652 21.006 16.9249 21.8366 15.5588 22.4017C14.1928 22.9668 12.7282 23.2551 11.2498 23.25ZM18.7575 13.096C18.9127 12.9437 18.9999 12.737 18.9999 12.5216C18.9999 12.3061 18.9127 12.0995 18.7575 11.9471C18.6023 11.7947 18.3918 11.7091 18.1724 11.7091H15.9655C15.812 11.709 15.6616 11.7507 15.5309 11.8296C15.4003 11.9085 15.2945 12.0215 15.2255 12.156L13.3096 15.9174L9.56615 6.27278C9.50796 6.12311 9.406 5.99367 9.27308 5.90073C9.14016 5.80778 8.98222 5.75549 8.81911 5.75043C8.656 5.74536 8.49501 5.78775 8.35637 5.87226C8.21773 5.95677 8.10764 6.07963 8.03994 6.22539L5.50132 11.7091H3.82753C3.60804 11.7091 3.39754 11.7947 3.24233 11.9471C3.08713 12.0995 2.99994 12.3061 2.99994 12.5216C2.99994 12.737 3.08713 12.9437 3.24233 13.096C3.39754 13.2484 3.60804 13.334 3.82753 13.334H6.03442C6.19301 13.3341 6.34831 13.2895 6.48182 13.2055C6.61533 13.1215 6.72145 13.0016 6.78753 12.8601L8.72408 8.67277L12.4337 18.2274C12.4908 18.3748 12.5904 18.5028 12.7204 18.5956C12.8503 18.6884 13.005 18.742 13.1655 18.75H13.2068C13.3605 18.75 13.5111 18.708 13.6418 18.6287C13.7724 18.5495 13.8781 18.436 13.9468 18.3012L16.4772 13.334H18.1724C18.3918 13.334 18.6023 13.2484 18.7575 13.096Z'
        fill='white'
        fillRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='clip0_221_14844'>
        <rect
          fill='white'
          height={size}
          transform='translate(0 0.75)'
          width={size}
        />
      </clipPath>
    </defs>
  </svg>

export const MonitorAvailablity = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 14 14'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M7.92851 0.532749C8.07351 0.578858 8.20017 0.670536 8.29009 0.794451C8.38001 0.918366 8.42849 1.06806 8.42848 1.22175V4.83286H11.2854C11.4161 4.83281 11.5443 4.86898 11.656 4.93746C11.7677 5.00594 11.8587 5.10409 11.9191 5.22123C11.9795 5.33838 12.007 5.47003 11.9985 5.60186C11.99 5.73369 11.946 5.86065 11.8711 5.96892L6.87144 13.1912C6.78442 13.3172 6.6599 13.4119 6.51599 13.4614C6.37208 13.511 6.21628 13.5128 6.07127 13.4667C5.92626 13.4205 5.7996 13.3288 5.70972 13.2048C5.61984 13.0808 5.57142 12.931 5.57152 12.7773V9.1662H2.71456C2.58391 9.16626 2.45575 9.13008 2.34402 9.06161C2.2323 8.99313 2.14128 8.89498 2.08089 8.77783C2.0205 8.66069 1.99304 8.52903 2.0015 8.3972C2.00996 8.26537 2.05402 8.13841 2.12888 8.03015L7.12856 0.807916C7.21571 0.682095 7.34026 0.587647 7.48411 0.538293C7.62797 0.488939 7.78364 0.48725 7.92851 0.533472V0.532749Z'
      fill='white'
      fillRule='evenodd'
    />
  </svg>

export const MonitorPerformance = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 14 14'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7 1.5C3.1402 1.5 2.44279e-06 4.6402 2.44279e-06 8.5C-0.000905047 9.58036 0.251047 10.6459 0.735702 11.6115C0.854702 11.8495 1.0969 12 1.3622 12H12.6371C12.9024 12 13.1453 11.8495 13.2643 11.6115C13.749 10.6459 14.0009 9.58036 14 8.5C14 4.6402 10.8598 1.5 7 1.5ZM10.5154 5.0154L7.742 9.242C7.66484 9.35983 7.5652 9.46129 7.44878 9.54056C7.33236 9.61983 7.20145 9.67536 7.06354 9.70397C6.92563 9.73258 6.78343 9.73371 6.64508 9.70729C6.50674 9.68087 6.37496 9.62742 6.2573 9.55C6.10839 9.45262 5.98609 9.31968 5.90145 9.16318C5.8168 9.00669 5.77247 8.83157 5.77247 8.65365C5.77247 8.47573 5.8168 8.30061 5.90145 8.14411C5.98609 7.98762 6.10839 7.85468 6.2573 7.7573L10.4839 4.9839C10.489 4.98072 10.4952 4.97968 10.5011 4.98099C10.507 4.98229 10.5121 4.98585 10.5154 4.9909C10.5176 4.9946 10.5188 4.99883 10.5188 5.00315C10.5188 5.00746 10.5176 5.0117 10.5154 5.0154Z'
      fill='white'
    />
  </svg>

export const TestCaseTag = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.0006 22.5429C11.1908 22.5429 10.3811 22.2342 9.76362 21.618L2.38327 14.2376C1.79491 13.6493 1.45708 12.8332 1.45708 12.0006V6.7295C1.45708 3.82189 3.82188 1.45709 6.72949 1.45709H12.007C12.8382 1.45709 13.6518 1.79492 14.2389 2.3858L21.618 9.76489C22.8516 10.9985 22.8516 13.0053 21.618 14.2376L14.2376 21.618C13.6214 22.2342 12.8117 22.5429 12.0006 22.5429ZM6.72949 3.56631C4.98467 3.56631 3.5663 4.98468 3.5663 6.7295V12.0019C3.5663 12.2803 3.67891 12.551 3.87376 12.7459L11.2554 20.1275C11.6666 20.5387 12.3347 20.5387 12.7459 20.1275L20.1262 12.7471C20.5374 12.3359 20.5374 11.6679 20.1262 11.2567L12.7459 3.8763C12.5498 3.67892 12.2803 3.56757 12.0044 3.56757H6.72822L6.72949 3.56631ZM6.73961 7.78347C6.15758 7.78347 5.67931 7.31152 5.67931 6.7295C5.67931 6.14747 6.1462 5.67552 6.72822 5.67552H6.73834C7.32037 5.67552 7.79232 6.14747 7.79232 6.7295C7.79232 7.31152 7.32037 7.78347 6.73834 7.78347H6.73961Z'
      fill='#55595C'
    />
    <path
      clipRule='evenodd'
      d='M13.6452 8.40537C14.1638 8.40536 14.5841 8.82574 14.5841 9.34429L14.5841 14.6557C14.5841 15.1742 14.1638 15.5946 13.6452 15.5946L10.9895 15.5946C10.471 15.5946 10.0506 15.1742 10.0506 14.6557C10.0506 14.1371 10.471 13.7167 10.9895 13.7167L12.7063 13.7167L12.7063 9.34429C12.7063 8.82574 13.1266 8.40536 13.6452 8.40537Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
  </svg>

export const RequirementGroup = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 21 21'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M0.791016 9.99979C0.791016 5.73318 4.24978 2.27441 8.51639 2.27441C12.783 2.27441 16.2418 5.73318 16.2418 9.99979C16.2418 14.2664 12.783 17.7252 8.51639 17.7252C4.24978 17.7252 0.791016 14.2664 0.791016 9.99979ZM7.68115 4.11606C5.06785 4.48369 3.00028 6.55127 2.63266 9.16457H4.47946C4.86387 9.16457 5.17549 9.53851 5.17549 9.9998C5.17549 10.4611 4.86387 10.835 4.47946 10.835H2.63266C3.00028 13.4483 5.06785 15.5159 7.68115 15.8835V14.0367C7.68115 13.6523 8.05509 13.3406 8.51637 13.3406C8.97766 13.3406 9.3516 13.6523 9.3516 14.0367V15.8835C11.9649 15.5159 14.0325 13.4483 14.4001 10.835H12.5532C12.1688 10.835 11.8572 10.4611 11.8572 9.9998C11.8572 9.53851 12.1688 9.16457 12.5532 9.16457H14.4001C14.0325 6.55126 11.9649 4.48367 9.3516 4.11605V5.96291C9.3516 6.34731 8.97766 6.65893 8.51637 6.65893C8.05509 6.65893 7.68115 6.34731 7.68115 5.96291V4.11606ZM16.3327 2.56939C15.9109 2.38526 15.4197 2.57794 15.2356 2.99974C15.0515 3.42154 15.2442 3.91274 15.666 4.09687C17.7903 5.0242 19.3327 7.29714 19.3327 9.99979C19.3327 12.7024 17.7903 14.9754 15.666 15.9027C15.2442 16.0868 15.0515 16.578 15.2356 16.9998C15.4197 17.4216 15.9109 17.6143 16.3327 17.4302C19.0947 16.2245 20.9994 13.3314 20.9994 9.99979C20.9994 6.66819 19.0947 3.77506 16.3327 2.56939Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
  </svg>

export const RequirementStatus = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 20 20'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M8.71668 2.56247C8.84428 3.00466 8.58925 3.46657 8.14706 3.59417C5.36561 4.3968 3.33268 6.96226 3.33268 10.0004C3.33268 11.372 3.74603 12.6446 4.45481 13.7035C4.71082 14.0859 4.60831 14.6035 4.22585 14.8595C3.84339 15.1156 3.32581 15.013 3.0698 14.6306C2.18312 13.306 1.66602 11.7123 1.66602 10.0004C1.66602 6.2 4.20929 2.9958 7.68497 1.99285C8.12717 1.86524 8.58908 2.12027 8.71668 2.56247ZM11.3831 2.58046C11.5167 2.14006 11.9821 1.89139 12.4225 2.02504C15.1129 2.84151 17.226 4.98 18.0069 7.68602C18.1345 8.12821 17.8794 8.59012 17.4373 8.71772C16.9951 8.84532 16.5331 8.59029 16.4055 8.14809C15.7814 5.98521 14.0893 4.2726 11.9385 3.61988C11.4981 3.48623 11.2494 3.02087 11.3831 2.58046ZM17.4373 11.283C17.8794 11.4106 18.1345 11.8725 18.0069 12.3147C17.0039 15.7904 13.7997 18.3337 9.99935 18.3337C8.67044 18.3337 7.41194 18.022 6.29515 17.467C5.88301 17.2622 5.71493 16.7621 5.91975 16.3499C6.12457 15.9378 6.62473 15.7697 7.03688 15.9745C7.92835 16.4175 8.93352 16.667 9.99935 16.667C13.0375 16.667 15.6029 14.6341 16.4055 11.8526C16.5331 11.4105 16.9951 11.1554 17.4373 11.283Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M10.0007 7.49967C8.61994 7.49967 7.50065 8.61896 7.50065 9.99967C7.50065 11.3804 8.61994 12.4997 10.0007 12.4997C11.3814 12.4997 12.5006 11.3804 12.5006 9.99967C12.5006 8.61896 11.3814 7.49967 10.0007 7.49967ZM5.83398 9.99967C5.83398 7.69849 7.69946 5.83301 10.0007 5.83301C12.3018 5.83301 14.1673 7.69849 14.1673 9.99967C14.1673 12.3009 12.3018 14.1663 10.0007 14.1663C7.69946 14.1663 5.83398 12.3009 5.83398 9.99967Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
  </svg>

export const Requirements = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 18 18'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M12.75 9C12.75 8.58579 13.0858 8.25 13.5 8.25H16.5C16.9142 8.25 17.25 8.58579 17.25 9C17.25 9.41421 16.9142 9.75 16.5 9.75H13.5C13.0858 9.75 12.75 9.41421 12.75 9Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M0.75 9C0.75 8.58579 1.08579 8.25 1.5 8.25H4.5C4.91421 8.25 5.25 8.58579 5.25 9C5.25 9.41421 4.91421 9.75 4.5 9.75H1.5C1.08579 9.75 0.75 9.41421 0.75 9Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M9 0.75C9.41421 0.75 9.75 1.08579 9.75 1.5V4.5C9.75 4.91421 9.41421 5.25 9 5.25C8.58579 5.25 8.25 4.91421 8.25 4.5V1.5C8.25 1.08579 8.58579 0.75 9 0.75Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M9 12.75C9.41421 12.75 9.75 13.0858 9.75 13.5V16.5C9.75 16.9142 9.41421 17.25 9 17.25C8.58579 17.25 8.25 16.9142 8.25 16.5V13.5C8.25 13.0858 8.58579 12.75 9 12.75Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
  </svg>

export const TestCaseAddStep = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 18 18'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M15.75 13.5C16.3467 13.5 16.919 13.2629 17.341 12.841C17.7629 12.419 18 11.8467 18 11.25L18 5.25C18 4.65326 17.7629 4.08097 17.341 3.65901C16.919 3.23705 16.3467 3 15.75 3L2.25 3C1.65326 3 1.08097 3.23705 0.659009 3.65901C0.237053 4.08097 2.89065e-07 4.65326 3.93402e-07 5.25L1.44248e-06 11.25C1.54681e-06 11.8467 0.237053 12.419 0.65901 12.841C1.08097 13.2629 1.65326 13.5 2.25 13.5L3 13.5C3.41421 13.5 3.75 13.1642 3.75 12.75C3.75 12.3358 3.41421 12 3 12L2.25 12C2.05109 12 1.86032 11.921 1.71967 11.7803C1.57902 11.6397 1.5 11.4489 1.5 11.25L1.5 5.25C1.5 5.05109 1.57902 4.86032 1.71967 4.71967C1.86032 4.57902 2.05109 4.5 2.25 4.5L15.75 4.5C15.9489 4.5 16.1397 4.57902 16.2803 4.71967C16.421 4.86032 16.5 5.05108 16.5 5.25L16.5 11.25C16.5 11.4489 16.421 11.6397 16.2803 11.7803C16.1397 11.921 15.9489 12 15.75 12L15 12C14.5858 12 14.25 12.3358 14.25 12.75C14.25 13.1642 14.5858 13.5 15 13.5L15.75 13.5ZM9.75 10.5C9.75 10.0858 9.41421 9.75 9 9.75C8.58579 9.75 8.25 10.0858 8.25 10.5L8.25 12L6.75 12C6.33579 12 6 12.3358 6 12.75C6 13.1642 6.33579 13.5 6.75 13.5L8.25 13.5L8.25 15C8.25 15.4142 8.58579 15.75 9 15.75C9.41422 15.75 9.75 15.4142 9.75 15L9.75 13.5L11.25 13.5C11.6642 13.5 12 13.1642 12 12.75C12 12.3358 11.6642 12 11.25 12L9.75 12L9.75 10.5Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
  </svg>

export const TestCaseSubModel = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 18 18'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M11.25 4.5C11.25 4.91421 11.0821 5.25 10.875 5.25L6.375 5.25C6.16789 5.25 6 4.91421 6 4.5C6 4.08579 6.16789 3.75 6.375 3.75L10.875 3.75C11.0821 3.75 11.25 4.08579 11.25 4.5Z'
      fill='white'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M15 13.5C15 12.6716 14.3284 12 13.5 12C12.6716 12 12 12.6716 12 13.5C12 14.3284 12.6716 15 13.5 15C14.3284 15 15 14.3284 15 13.5ZM13.5 10.5C15.1569 10.5 16.5 11.8431 16.5 13.5C16.5 15.1569 15.1569 16.5 13.5 16.5C11.8431 16.5 10.5 15.1569 10.5 13.5C10.5 11.8431 11.8431 10.5 13.5 10.5Z'
      fill='white'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M15 4.5C15 3.67157 14.3284 3 13.5 3C12.6716 3 12 3.67157 12 4.5C12 5.32843 12.6716 6 13.5 6C14.3284 6 15 5.32843 15 4.5ZM13.5 1.5C15.1569 1.5 16.5 2.84315 16.5 4.5C16.5 6.15685 15.1569 7.5 13.5 7.5C11.8431 7.5 10.5 6.15685 10.5 4.5C10.5 2.84315 11.8431 1.5 13.5 1.5Z'
      fill='white'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6C5.32843 6 6 5.32843 6 4.5ZM4.5 1.5C6.15685 1.5 7.5 2.84315 7.5 4.5C7.5 6.15685 6.15685 7.5 4.5 7.5C2.84315 7.5 1.5 6.15685 1.5 4.5C1.5 2.84315 2.84315 1.5 4.5 1.5Z'
      fill='white'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M12 13.5C12 13.9142 11.6642 14.25 11.25 14.25C9.26088 14.25 7.35322 13.4598 5.9467 12.0533C4.54018 10.6468 3.75 8.73912 3.75 6.75C3.75 6.33579 4.08579 6 4.5 6C4.91421 6 5.25 6.33579 5.25 6.75C5.25 8.3413 5.88214 9.86742 7.00736 10.9926C8.13258 12.1179 9.6587 12.75 11.25 12.75C11.6642 12.75 12 13.0858 12 13.5Z'
      fill='white'
      fillRule='evenodd'
    />
  </svg>

export const TestCaseSubModelCurrentColor = ({ size = '14' }: IconInterface) =>
  <svg
    fill='currentColor'
    height={size}
    viewBox='0 0 18 18'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M11.25 4.5C11.25 4.91421 11.0821 5.25 10.875 5.25L6.375 5.25C6.16789 5.25 6 4.91421 6 4.5C6 4.08579 6.16789 3.75 6.375 3.75L10.875 3.75C11.0821 3.75 11.25 4.08579 11.25 4.5Z'
      fill='currentColor'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M15 13.5C15 12.6716 14.3284 12 13.5 12C12.6716 12 12 12.6716 12 13.5C12 14.3284 12.6716 15 13.5 15C14.3284 15 15 14.3284 15 13.5ZM13.5 10.5C15.1569 10.5 16.5 11.8431 16.5 13.5C16.5 15.1569 15.1569 16.5 13.5 16.5C11.8431 16.5 10.5 15.1569 10.5 13.5C10.5 11.8431 11.8431 10.5 13.5 10.5Z'
      fill='currentColor'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M15 4.5C15 3.67157 14.3284 3 13.5 3C12.6716 3 12 3.67157 12 4.5C12 5.32843 12.6716 6 13.5 6C14.3284 6 15 5.32843 15 4.5ZM13.5 1.5C15.1569 1.5 16.5 2.84315 16.5 4.5C16.5 6.15685 15.1569 7.5 13.5 7.5C11.8431 7.5 10.5 6.15685 10.5 4.5C10.5 2.84315 11.8431 1.5 13.5 1.5Z'
      fill='currentColor'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6C5.32843 6 6 5.32843 6 4.5ZM4.5 1.5C6.15685 1.5 7.5 2.84315 7.5 4.5C7.5 6.15685 6.15685 7.5 4.5 7.5C2.84315 7.5 1.5 6.15685 1.5 4.5C1.5 2.84315 2.84315 1.5 4.5 1.5Z'
      fill='currentColor'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M12 13.5C12 13.9142 11.6642 14.25 11.25 14.25C9.26088 14.25 7.35322 13.4598 5.9467 12.0533C4.54018 10.6468 3.75 8.73912 3.75 6.75C3.75 6.33579 4.08579 6 4.5 6C4.91421 6 5.25 6.33579 5.25 6.75C5.25 8.3413 5.88214 9.86742 7.00736 10.9926C8.13258 12.1179 9.6587 12.75 11.25 12.75C11.6642 12.75 12 13.0858 12 13.5Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>

export const TestCasePrevious = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 18 18'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M7.28033 3.21967C7.57322 3.51256 7.57322 3.98744 7.28033 4.28033L5.56066 6H11.25C11.6642 6 12 6.33579 12 6.75C12 7.16421 11.6642 7.5 11.25 7.5H5.56066L7.28033 9.21967C7.57322 9.51256 7.57322 9.98744 7.28033 10.2803C6.98744 10.5732 6.51256 10.5732 6.21967 10.2803L3.21997 7.28063L3.21808 7.27874C3.14696 7.2072 3.09324 7.12489 3.05691 7.03709C3.02024 6.94866 3 6.85169 3 6.75C3 6.64831 3.02024 6.55134 3.05691 6.46291C3.09351 6.37445 3.14776 6.29158 3.21967 6.21967L6.21967 3.21967C6.51256 2.92678 6.98744 2.92678 7.28033 3.21967Z'
      fill='white'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M5.25 6H11.1C13.3911 6 15.2625 7.83903 15.2625 10.125C15.2625 12.411 13.3911 14.25 11.1 14.25H8.625C8.21079 14.25 7.875 13.9142 7.875 13.5C7.875 13.0858 8.21079 12.75 8.625 12.75H11.1C12.5783 12.75 13.7625 11.567 13.7625 10.125C13.7625 8.68304 12.5783 7.5 11.1 7.5H5.25V6Z'
      fill='white'
      fillRule='evenodd'
    />
  </svg>

export const RefreshEnabled = ({ size = '16' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 16 16'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Custom / Refresh-Enabled'>
      <path
        clipRule='evenodd'
        d='M4.97385 2.81757C6.12084 2.1478 7.45764 1.8775 8.77475 2.04904C10.0919 2.22059 11.3148 2.82427 12.252 3.7655C13.1892 4.70672 13.7876 5.93228 13.9534 7.25012C13.9994 7.61543 13.7406 7.94884 13.3753 7.99482C13.0099 8.04079 12.6765 7.78193 12.6306 7.41662C12.5015 6.3916 12.0361 5.43836 11.3072 4.70627C10.5782 3.97419 9.62699 3.50464 8.60255 3.37121C7.5781 3.23778 6.53833 3.44802 5.64619 3.96898C5.05686 4.31311 4.55395 4.77999 4.16882 5.33337H5.33333C5.70152 5.33337 6 5.63184 6 6.00003C6 6.36822 5.70152 6.6667 5.33333 6.6667H3.06973C3.05956 6.66694 3.04937 6.66694 3.03915 6.6667H2.66667C2.29848 6.6667 2 6.36822 2 6.00003V3.33337C2 2.96518 2.29848 2.6667 2.66667 2.6667C3.03486 2.6667 3.33333 2.96518 3.33333 3.33337V4.22685C3.78729 3.66535 4.34192 3.18658 4.97385 2.81757ZM2.62427 8.00531C2.98955 7.95907 3.32315 8.2177 3.36939 8.58297C3.4991 9.60762 3.96493 10.5603 4.69394 11.292C5.42295 12.0236 6.37398 12.4928 7.39816 12.6262C8.42234 12.7596 9.46184 12.5496 10.3539 12.0291C10.9429 11.6854 11.4456 11.2193 11.8309 10.6667H10.6667C10.2985 10.6667 10 10.3682 10 10C10 9.63184 10.2985 9.33337 10.6667 9.33337H12.9309C12.9411 9.33313 12.9513 9.33313 12.9615 9.33337H13.3333C13.7015 9.33337 14 9.63184 14 10V12.6667C14 13.0349 13.7015 13.3334 13.3333 13.3334C12.9651 13.3334 12.6667 13.0349 12.6667 12.6667V11.7724C12.2125 12.3336 11.6578 12.812 11.0259 13.1807C9.87901 13.8499 8.54265 14.1198 7.22597 13.9484C5.9093 13.7769 4.68665 13.1736 3.74944 12.2331C2.81223 11.2925 2.21337 10.0677 2.04661 8.75043C2.00037 8.38515 2.259 8.05155 2.62427 8.00531Z'
        fill='#36B15B'
        fillRule='evenodd'
      />
      <path
        d='M10.4713 6.19526C10.7317 6.45561 10.7317 6.87772 10.4713 7.13807L7.80466 9.80474C7.54431 10.0651 7.1222 10.0651 6.86185 9.80474L5.52851 8.4714C5.26816 8.21106 5.26816 7.78894 5.52851 7.5286C5.78886 7.26825 6.21097 7.26825 6.47132 7.5286L7.33325 8.39052L9.52851 6.19526C9.78886 5.93491 10.211 5.93491 10.4713 6.19526Z'
        fill='#36B15B'
      />
    </g>
  </svg>

export const CustomScript = ({ size = '14' }: IconInterface) =>
  <svg
    fill='currentColor'
    height={size}
    viewBox='0 0 120 120'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M71.1752 8.77536C68.3251 -2.92479 51.6749 -2.92479 48.8249 8.77536C48.3994 10.5335 47.5648 12.1663 46.389 13.541C45.2133 14.9157 43.7295 15.9933 42.0586 16.6862C40.3877 17.3792 38.5768 17.6678 36.7733 17.5287C34.9697 17.3895 33.2245 16.8265 31.6797 15.8855C21.3895 9.61538 9.61435 21.3905 15.8844 31.6807C19.9345 38.3258 16.3419 46.9959 8.78184 48.8334C-2.92582 51.6759 -2.92582 68.3337 8.78184 71.1687C10.5405 71.5948 12.1736 72.4301 13.5482 73.6068C14.9229 74.7834 16.0002 76.2681 16.6925 77.94C17.3848 79.6118 17.6724 81.4235 17.532 83.2275C17.3916 85.0315 16.8271 86.7769 15.8844 88.3214C9.61435 98.6116 21.3895 110.387 31.6797 104.117C33.2242 103.174 34.9696 102.61 36.7736 102.469C38.5776 102.329 40.3893 102.616 42.0611 103.309C43.733 104.001 45.2177 105.078 46.3943 106.453C47.571 107.828 48.4063 109.461 48.8324 111.219C51.6749 122.927 68.3327 122.927 71.1677 111.219C71.5952 109.462 72.4314 107.83 73.6083 106.456C74.7852 105.082 76.2696 104.005 77.9409 103.313C79.6123 102.621 81.4233 102.333 83.2268 102.473C85.0303 102.613 86.7755 103.176 88.3204 104.117C98.6106 110.387 110.386 98.6116 104.116 88.3214C103.175 86.7765 102.612 85.0313 102.472 83.2278C102.332 81.4243 102.62 79.6133 103.312 77.9419C104.004 76.2706 105.081 74.7862 106.455 73.6093C107.829 72.4324 109.461 71.5962 111.218 71.1687C122.926 68.3262 122.926 51.6684 111.218 48.8334C109.46 48.4074 107.826 47.572 106.452 46.3953C105.077 45.2187 104 43.734 103.308 42.0622C102.615 40.3903 102.328 38.5787 102.468 36.7746C102.609 34.9706 103.173 33.2252 104.116 31.6807C110.386 21.3905 98.6106 9.61538 88.3204 15.8855C86.7759 16.8281 85.0305 17.3926 83.2265 17.533C81.4224 17.6734 79.6108 17.3858 77.9389 16.6935C76.2671 16.0012 74.7824 14.9239 73.6058 13.5493C72.4291 12.1746 71.5937 10.5415 71.1677 8.78286L71.1752 8.77536Z
  M53.0474 37.5083C54.4037 37.5742 55.7166 38.0071 56.8461 38.7607L79.3464 53.7609C80.3736 54.4458 81.2159 55.3737 81.7984 56.4623C82.3809 57.5508 82.6857 58.7663 82.6857 60.0009C82.6857 61.2356 82.3809 62.4511 81.7984 63.5396C81.2159 64.6282 80.3736 65.5561 79.3464 66.241L56.8461 81.2412C55.7166 81.9948 54.4037 82.4277 53.0474 82.4935C51.6912 82.5594 50.3425 82.2559 49.1453 81.6153C47.948 80.9747 46.9472 80.0211 46.2494 78.8563C45.5517 77.6914 45.1833 76.359 45.1835 75.0011V45.0007C45.1833 43.6429 45.5517 42.3105 46.2494 41.1456C46.9472 39.9808 47.948 39.0272 49.1453 38.3866C50.3425 37.746 51.6912 37.4425 53.0474 37.5083Z'
    />
  </svg>

export const Webhook = ({ size = '14' }: IconInterface) =>
  <svg
    fill='currentColor'
    height={size}
    viewBox='0 0 14 14'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.8654 6.53346L11.8655 6.53351C12.8437 7.09985 13.5001 8.15683 13.5001 9.36477C13.5001 11.1688 12.035 12.6339 10.2308 12.6339C8.58572 12.6339 7.22164 11.4152 6.99493 9.8323L6.93347 9.40319H6.49998H3.76938C3.74835 9.40319 3.73096 9.3858 3.73096 9.36477C3.73096 9.34375 3.74835 9.32635 3.76938 9.32635H6.99311V9.3264L6.99977 9.32631C7.00972 9.32617 7.01975 9.33008 7.02729 9.33752L7.37835 8.98163L7.02699 9.33722C7.03437 9.34451 7.0385 9.3544 7.0385 9.36477C7.0385 11.1268 8.46879 12.5571 10.2308 12.5571C11.9929 12.5571 13.4232 11.1268 13.4232 9.36477C13.4232 8.18296 12.7794 7.15156 11.827 6.60007C11.8087 6.58947 11.8024 6.56569 11.813 6.54744C11.8236 6.52921 11.8475 6.52306 11.8654 6.53346Z'
      fill='currentColor'
      stroke='white'
    />
    <path
      clipRule='evenodd'
      d='M4.3078 3.76988C4.30745 4.06704 4.06585 4.30812 3.76868 4.30777C3.47151 4.30725 3.23044 4.06582 3.23096 3.76848C3.23253 2.46728 3.90856 1.2018 5.11552 0.505036C6.91716 -0.535051 9.22413 0.0829743 10.2644 1.88462C11.213 3.52793 10.7821 5.5919 9.33196 6.7311L10.6973 9.0959C10.8458 9.35318 10.7575 9.68275 10.5001 9.83133C10.2428 9.97992 9.91323 9.8916 9.76464 9.63433L8.15269 6.84241C8.07918 6.71874 8.05811 6.5705 8.09451 6.43115C8.13092 6.2918 8.2215 6.17282 8.34622 6.10088C9.63313 5.35779 10.0747 3.70995 9.33178 2.42304C8.58869 1.1363 6.94085 0.694729 5.65394 1.43765C4.79152 1.93566 4.30902 2.84005 4.3078 3.76988Z'
      fill='white'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M5.11597 11.6966C5.3736 11.5484 5.70299 11.637 5.8514 11.8947C5.99964 12.1521 5.91097 12.4817 5.65335 12.6299C4.52564 13.2791 3.09171 13.3263 1.88475 12.6296C0.0831044 11.5893 -0.535095 9.28234 0.504992 7.48069C1.4538 5.83738 3.45664 5.1786 5.1684 5.86491L6.5337 3.50028C6.68229 3.24283 7.01185 3.15451 7.26931 3.3031C7.52658 3.45168 7.6149 3.78125 7.46631 4.0387L5.85454 6.83044C5.78416 6.95621 5.66624 7.04835 5.52741 7.0865C5.38858 7.12482 5.24017 7.10566 5.11545 7.03372C3.82853 6.2908 2.1807 6.73237 1.43778 8.01911C0.694685 9.30603 1.13626 10.9539 2.42317 11.697C3.28558 12.1948 4.31017 12.1605 5.11597 11.6966Z'
      fill='currentColor'
      fillRule='evenodd'
    />
    <path
      d='M10.2306 11.1149C11.1971 11.1149 11.9806 10.3314 11.9806 9.36483C11.9806 8.39829 11.1971 7.61475 10.2306 7.61475C9.26401 7.61475 8.48047 8.39829 8.48047 9.36483C8.48047 10.3314 9.26401 11.1149 10.2306 11.1149Z'
      fill='currentColor'
    />
    <path
      clipRule='evenodd'
      d='M5.48454 4.64417C5.00151 3.80771 5.28858 2.73644 6.12504 2.25358C6.9615 1.77056 8.03276 2.05762 8.51562 2.89408C8.99847 3.73054 8.71158 4.80181 7.87512 5.28466C7.03866 5.76769 5.9674 5.48062 5.48454 4.64417Z'
      fill='currentColor'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M5.285 10.2404C4.80197 11.0769 3.73087 11.3638 2.89442 10.8809C2.05778 10.3979 1.77089 9.32678 2.25374 8.49032C2.73677 7.65387 3.80787 7.3668 4.64433 7.84965C5.48079 8.33268 5.76785 9.40378 5.285 10.2404Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>

export const WebhookNotificationIcon = ({ size = '15' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 15 15'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.64147 14.0713C2.45838 14.0713 1.28954 13.4726 0.619601 12.4035C-0.420948 10.7358 0.0779457 8.52642 1.74568 7.48587C2.07352 7.27206 2.5154 7.37184 2.72921 7.71394C2.94302 8.04178 2.84324 8.48366 2.50114 8.69747C1.50336 9.32465 1.20402 10.6503 1.8312 11.6481C2.45838 12.6459 3.78401 12.9452 4.7818 12.318C5.40898 11.9189 5.77958 11.249 5.77958 10.5077C5.77958 10.1086 6.09317 9.79504 6.49229 9.79504H10.7685C11.1676 9.79504 11.4812 10.1086 11.4812 10.5077C11.4812 10.9069 11.1676 11.2204 10.7685 11.2204H7.13372C6.94842 12.1755 6.37826 13.0022 5.53727 13.5296C4.95285 13.9002 4.29716 14.0713 3.65572 14.0713H3.64147Z'
      fill='#AFAFAF'
    />
    <path
      d='M10.7685 14.0714C10.1698 14.0714 9.58543 13.9146 9.04378 13.6295C8.70168 13.4442 8.57339 13.0023 8.75869 12.6602C8.944 12.3181 9.38587 12.1898 9.72797 12.3752C10.2269 12.646 10.8113 12.7172 11.3529 12.5605C11.9088 12.4037 12.3507 12.0331 12.6358 11.5342C12.9066 11.0353 12.9779 10.4508 12.8211 9.90919C12.6643 9.36754 12.2937 8.9114 11.7948 8.62632C11.1391 8.26997 10.2696 8.29848 9.68521 8.62632C9.51416 8.71185 9.3146 8.74036 9.14355 8.68334C8.95825 8.62632 8.80146 8.51229 8.71593 8.34124L6.57782 4.42136C6.39251 4.07927 6.5208 3.63739 6.8629 3.45208C7.205 3.26678 7.64687 3.39507 7.83218 3.73717L9.6567 7.08688C10.569 6.8018 11.6238 6.88732 12.479 7.37196C13.3058 7.82809 13.9187 8.58356 14.1753 9.51008C14.4318 10.4223 14.332 11.3916 13.8759 12.2184C13.4198 13.0451 12.6643 13.658 11.7521 13.9146C11.4242 14.0144 11.0964 14.0571 10.7543 14.0571L10.7685 14.0714Z'
      fill='#AFAFAF'
    />
    <path
      d='M3.64146 11.2204C3.52743 11.2204 3.41339 11.1918 3.29936 11.1348C2.95726 10.9495 2.82898 10.5077 3.01428 10.1656L4.85306 6.80159C4.09759 6.1459 3.64146 5.14811 3.64146 4.09331C3.64146 2.12624 5.23792 0.529785 7.20498 0.529785C9.17205 0.529785 10.7685 2.12624 10.7685 4.09331C10.7685 4.49242 10.4549 4.80601 10.0558 4.80601C9.65669 4.80601 9.3431 4.49242 9.3431 4.09331C9.3431 2.91022 8.38807 1.95519 7.20498 1.95519C6.02189 1.95519 5.06687 2.91022 5.06687 4.09331C5.06687 4.89154 5.46598 5.60424 6.12167 5.9606C6.46377 6.1459 6.59206 6.58778 6.40675 6.92987L4.26864 10.8498C4.14035 11.0921 3.89803 11.2204 3.64146 11.2204Z'
      fill='#AFAFAF'
    />
  </svg>

export const EmailNotification = ({ size = '17' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 17 17'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M2.11442 3.55258C2.48949 3.17751 2.9982 2.9668 3.52864 2.9668H12.862C13.3924 2.9668 13.9011 3.17751 14.2762 3.55258C14.6513 3.92766 14.862 4.43636 14.862 4.9668V5.62312C14.8621 5.62961 14.8621 5.6361 14.862 5.64258V11.6335C14.862 12.1639 14.6513 12.6726 14.2762 13.0477C13.9011 13.4227 13.3924 13.6335 12.862 13.6335H3.52864C2.9982 13.6335 2.48949 13.4227 2.11442 13.0477C1.73935 12.6726 1.52864 12.1639 1.52864 11.6335V5.64258C1.52854 5.6361 1.52854 5.62961 1.52864 5.62312V4.9668C1.52864 4.43636 1.73935 3.92766 2.11442 3.55258ZM2.86197 6.87914V11.6335C2.86197 11.8103 2.93221 11.9798 3.05723 12.1049C3.18226 12.2299 3.35182 12.3001 3.52864 12.3001H12.862C13.0388 12.3001 13.2083 12.2299 13.3334 12.1049C13.4584 11.9798 13.5286 11.8103 13.5286 11.6335V6.87914L9.3053 9.6947C9.30523 9.69474 9.30517 9.69479 9.3051 9.69483C8.97648 9.91402 8.59032 10.031 8.1953 10.031C7.80029 10.031 7.41412 9.91402 7.0855 9.69483C7.08543 9.69479 7.08537 9.69474 7.0853 9.6947L2.86197 6.87914ZM13.5286 5.27667L8.5655 8.58543L8.5653 8.58556C8.45575 8.65866 8.327 8.69766 8.1953 8.69766C8.0636 8.69766 7.93485 8.65866 7.8253 8.58556L7.8251 8.58543L2.86197 5.27667V4.9668C2.86197 4.78999 2.93221 4.62042 3.05723 4.49539C3.18225 4.37037 3.35182 4.30013 3.52864 4.30013H12.862C13.0388 4.30013 13.2083 4.37037 13.3334 4.49539C13.4584 4.62042 13.5286 4.78999 13.5286 4.9668V5.27667Z'
      fill='#AFAFAF'
      fillRule='evenodd'
    />
  </svg>

export const Feature = ({ size = '14' }: IconInterface) =>
  <svg
    fill='currentColor'
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Custom/Feature'>
      <path
        d='M15.3334 2.56956C14.9116 2.38544 14.4204 2.57811 14.2363 2.99991C14.0522 3.42171 14.2449 3.91291 14.6667 4.09704C16.791 5.02437 18.3334 7.29732 18.3334 9.99997C18.3334 12.7026 16.791 14.9756 14.6667 15.9029C14.2449 16.087 14.0522 16.5782 14.2363 17C14.4204 17.4218 14.9116 17.6145 15.3334 17.4304C18.0954 16.2247 20 13.3316 20 9.99997C20 6.66836 18.0954 3.77523 15.3334 2.56956Z'
        fill='var(--icon)'
      />
      <path
        d='M10.8242 4.54079L10.8244 4.5409C12.6657 5.59982 13.836 7.8583 13.6895 10.1099L13.7394 10.1132L13.6895 10.1099C13.4829 13.2913 11.0658 15.9522 7.92994 17.044V16.8427C7.92994 16.1285 7.41085 15.516 6.69399 15.3801C5.88762 15.2273 5.12198 14.9151 4.44423 14.4628C3.7665 14.0105 3.19105 13.4278 2.75332 12.7505C2.31558 12.0733 2.0248 11.3159 1.89888 10.5252C1.77295 9.73433 1.81451 8.92676 2.02101 8.1522C2.22751 7.37763 2.5946 6.6524 3.09971 6.02126C3.60481 5.39013 4.23725 4.86644 4.95808 4.48254C5.6789 4.09865 6.4728 3.86271 7.29084 3.78932C8.1089 3.71593 8.93371 3.80664 9.71435 4.05585C9.72921 4.0606 9.74413 4.06512 9.75913 4.06941C9.8057 4.08275 9.84398 4.09695 9.93158 4.12951L9.93178 4.12959C9.9634 4.14134 10.0013 4.15542 10.048 4.17258C10.0906 4.18868 10.1184 4.19942 10.1427 4.20943C10.1523 4.21337 10.1619 4.21721 10.1716 4.22095C10.2696 4.25901 10.3775 4.3072 10.5027 4.36707C10.6083 4.41909 10.7116 4.47474 10.8126 4.53403L10.8128 4.53414L10.8242 4.54079ZM6.35274 18.9482C6.35274 18.9627 6.35906 18.9765 6.37006 18.986C6.38105 18.9955 6.39564 18.9997 6.41001 18.9976C6.9125 18.9237 7.40858 18.815 7.89391 18.6737C11.7875 17.5404 14.997 14.3116 15.2636 10.2074C15.4443 7.42999 14.0239 4.59383 11.6251 3.2141C11.488 3.13367 11.3479 3.0583 11.2047 2.988L11.2043 2.9878C11.0585 2.91798 10.9078 2.84952 10.7545 2.79001C10.706 2.77006 10.6583 2.7519 10.61 2.73367L10.6096 2.73352L10.5292 2.70369L10.5283 2.70336C10.4229 2.66407 10.3146 2.62366 10.2038 2.59189C9.2189 2.27759 8.17843 2.16322 7.14652 2.2558C6.11436 2.3484 5.11255 2.6461 4.20283 3.13059C3.2931 3.61509 2.49471 4.27613 1.85694 5.07304C1.21917 5.86995 0.755527 6.78583 0.494683 7.76424C0.233838 8.74265 0.181337 9.76278 0.340407 10.7617C0.499476 11.7607 0.866773 12.7173 1.41954 13.5725C1.9723 14.4276 2.69883 15.1633 3.55428 15.7342C4.3983 16.2974 5.35019 16.6885 6.35274 16.884V18.9482Z'
        fill='var(--icon)'
        stroke='#55595C'
        strokeLinejoin='round'
        strokeWidth='0.1'
      />
      <path
        clipRule='evenodd'
        d='M4.90985 12.2478C4.66738 12.2478 4.43217 12.1221 4.30214 11.8982C4.10909 11.5611 4.22172 11.1356 4.55777 10.9406L5.51866 10.3869C5.85478 10.192 6.28284 10.3084 6.47572 10.6423C6.66887 10.9794 6.55624 11.405 6.22017 11.6L5.2596 12.1535L5.25828 12.1543C5.14977 12.2185 5.02946 12.2478 4.90985 12.2478ZM5.2596 7.61358L6.22017 8.16704C6.55626 8.36206 6.66885 8.78751 6.4758 9.1246C6.34577 9.34856 6.11056 9.47421 5.86808 9.47421C5.74847 9.47421 5.62817 9.44492 5.51966 9.3807L4.55758 8.82637C4.2215 8.63131 4.10906 8.20587 4.30222 7.86877C4.4951 7.53481 4.92348 7.41864 5.2596 7.61358ZM9.71165 9.47421C9.46919 9.47421 9.23399 9.34858 9.10396 9.12464C8.91088 8.78755 9.02348 8.36207 9.35956 8.16704L10.3205 7.6134C10.6566 7.41844 11.0847 7.53481 11.2775 7.86882C11.4707 8.20589 11.358 8.63142 11.022 8.82648L10.0614 9.37992L10.0601 9.3807C9.95157 9.44492 9.83126 9.47421 9.71165 9.47421ZM10.6699 12.2478C10.9124 12.2478 11.1476 12.1221 11.2776 11.8981C11.4706 11.5611 11.358 11.1356 11.022 10.9406L10.0611 10.3869C9.72497 10.192 9.29692 10.3083 9.10403 10.6423C8.91086 10.9794 9.02349 11.4049 9.35956 11.6L10.3201 12.1535L10.3215 12.1543C10.43 12.2185 10.5503 12.2478 10.6699 12.2478ZM8.49183 12.1021V13.2121C8.49183 13.5998 8.17818 13.9113 7.79253 13.9113C7.40715 13.9113 7.09323 13.5974 7.09323 13.2121V12.1021C7.09323 11.7143 7.40687 11.4028 7.79253 11.4028C8.17791 11.4028 8.49183 11.7167 8.49183 12.1021ZM8.49183 6.55501V7.66496C8.49183 8.05273 8.17818 8.36426 7.79253 8.36426C7.40715 8.36426 7.09323 8.05034 7.09323 7.66496V6.55501C7.09323 6.16724 7.40687 5.85571 7.79253 5.85571C8.17791 5.85571 8.49183 6.16963 8.49183 6.55501Z'
        fill='var(--icon)'
        fillRule='evenodd'
      />
    </g>
  </svg>

export const Scenario = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Custom/Scenario'>
      <path
        clipRule='evenodd'
        d='M13.5561 2.84758L13.5429 2.8398C13.4252 2.76966 13.3048 2.70384 13.1817 2.6423C13.0366 2.57189 12.9107 2.51476 12.7956 2.46946C12.7848 2.46522 12.7741 2.46087 12.7634 2.45641C12.7345 2.44435 12.7018 2.43151 12.6524 2.41258C12.5984 2.39246 12.5547 2.37597 12.5182 2.36219C12.4178 2.32431 12.3714 2.30682 12.3151 2.29047C12.2984 2.2856 12.2818 2.28049 12.2652 2.27512C11.3579 1.9812 10.3993 1.87422 9.44851 1.96077C8.49778 2.04733 7.57506 2.32558 6.7372 2.77838C5.89934 3.23119 5.1641 3.84895 4.57685 4.59356C3.98957 5.3382 3.5627 6.19392 3.32256 7.10797C3.08241 8.02202 3.03408 8.97503 3.18053 9.90829C3.32696 10.8415 3.66511 11.7352 4.17409 12.5343C4.68306 13.3333 5.35209 14.0208 6.13991 14.5543C6.92774 15.0878 7.81766 15.456 8.75484 15.6362C9.55508 15.7902 10.1328 16.4835 10.1328 17.2899V17.6073C13.802 16.3412 16.6463 13.1936 16.888 9.41711C17.0582 6.76224 15.6991 4.09822 13.5561 2.84758ZM10.1328 19.3757C9.57578 19.5402 9.00645 19.6669 8.4298 19.7529V17.2899C7.26432 17.0657 6.15763 16.6078 5.1779 15.9444C4.19817 15.2809 3.36618 14.426 2.73324 13.4323C2.1003 12.4386 1.67978 11.3273 1.49767 10.1667C1.31555 9.00611 1.37565 7.82095 1.6743 6.68424C1.97294 5.54753 2.50379 4.48338 3.23411 3.55737C3.96442 2.63136 4.87875 1.86313 5.92069 1.30003C6.96264 0.736931 8.11012 0.390902 9.29243 0.283266C10.4747 0.175631 11.6669 0.308661 12.7952 0.674182C12.921 0.710755 13.0445 0.757475 13.1669 0.803791C13.1979 0.81554 13.2289 0.827263 13.2599 0.838788C13.3157 0.860147 13.3701 0.881215 13.4254 0.904282C13.6004 0.9732 13.7729 1.05266 13.9404 1.1341C14.1044 1.21574 14.2647 1.30326 14.4215 1.39667C17.1669 2.99886 18.7946 6.29497 18.5876 9.52356C18.2822 14.295 14.6039 18.0551 10.1328 19.3757Z'
        fill='var(--icon)'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M6.44114 12.0792C6.13304 12.0792 5.83417 11.9196 5.66896 11.635C5.42366 11.2067 5.56677 10.6661 5.99377 10.4183L7.21471 9.71482C7.6418 9.46711 8.18571 9.61496 8.43079 10.0393C8.67621 10.4676 8.5331 11.0083 8.10607 11.2562L6.88554 11.9594L6.88386 11.9604C6.74599 12.042 6.59312 12.0792 6.44114 12.0792ZM6.88554 6.19089L8.10607 6.89413C8.53312 7.14193 8.67619 7.68253 8.43088 8.11085C8.26567 8.39542 7.9668 8.55507 7.6587 8.55507C7.50672 8.55507 7.35386 8.51785 7.21598 8.43625L5.99353 7.7319C5.56649 7.48405 5.42363 6.94347 5.66906 6.51514C5.91414 6.09079 6.45846 5.94318 6.88554 6.19089ZM12.5425 8.55507C12.2344 8.55507 11.9355 8.39543 11.7703 8.1109C11.525 7.68258 11.6681 7.14195 12.0951 6.89413L13.3161 6.19065C13.7432 5.94293 14.2871 6.0908 14.5322 6.5152C14.7775 6.9435 14.6344 7.48418 14.2074 7.73204L12.9869 8.43527L12.9852 8.43626C12.8473 8.51786 12.6945 8.55507 12.5425 8.55507ZM13.76 12.0792C14.0681 12.0792 14.367 11.9196 14.5322 11.635C14.7775 11.2067 14.6344 10.6661 14.2074 10.4183L12.9865 9.71482C12.5594 9.46712 12.0155 9.61495 11.7704 10.0393C11.525 10.4676 11.6681 11.0083 12.0951 11.2562L13.3156 11.9594L13.3173 11.9604C13.4552 12.042 13.6081 12.0792 13.76 12.0792ZM10.9925 11.8942V13.3045C10.9925 13.7972 10.594 14.1931 10.104 14.1931C9.6143 14.1931 9.21542 13.7942 9.21542 13.3045V11.8942C9.21542 11.4015 9.61395 11.0056 10.104 11.0056C10.5936 11.0056 10.9925 11.4045 10.9925 11.8942ZM10.9925 4.84583V6.25617C10.9925 6.74888 10.594 7.14473 10.104 7.14473C9.6143 7.14473 9.21542 6.74585 9.21542 6.25617V4.84583C9.21542 4.35312 9.61395 3.95728 10.104 3.95728C10.5936 3.95728 10.9925 4.35615 10.9925 4.84583Z'
        fill='var(--icon)'
        fillRule='evenodd'
      />
    </g>
  </svg>

export const SkippedStatus = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M9.2002 2C11.1095 2.00005 12.9408 2.75837 14.291 4.1084C15.6413 5.45866 16.4004 7.29064 16.4004 9.2002C16.4003 11.1097 15.6412 12.9408 14.291 14.291C12.9408 15.6412 11.1097 16.4003 9.2002 16.4004C7.29064 16.4004 5.45866 15.6413 4.1084 14.291C2.75837 12.9408 2.00005 11.1095 2 9.2002C2 7.29064 2.75814 5.45866 4.1084 4.1084C5.45866 2.75814 7.29064 2 9.2002 2ZM11.5 6C11.3674 6 11.2403 6.04561 11.1465 6.12598C11.0528 6.20632 11 6.31511 11 6.42871V8.55664C10.9223 8.41151 10.8098 8.28761 10.6729 8.19629L7.55469 6.16797C7.40427 6.0677 7.22939 6.00981 7.04883 6.00098C6.86809 5.9922 6.68789 6.03284 6.52832 6.11816C6.36877 6.20353 6.2356 6.33112 6.14258 6.48633C6.0496 6.64154 6.00003 6.81907 6 7V11C5.99997 11.181 6.04959 11.3584 6.14258 11.5137C6.2356 11.669 6.3687 11.7964 6.52832 11.8818C6.68793 11.9672 6.86802 12.0078 7.04883 11.999C7.22946 11.9902 7.40423 11.9324 7.55469 11.832L10.6729 9.86035C10.7757 9.79179 10.8647 9.70492 10.9355 9.60449L11 9.5V11.5713C11 11.685 11.0527 11.7946 11.1465 11.875C11.2402 11.9553 11.3675 12 11.5 12C11.6325 12 11.7598 11.9553 11.8535 11.875C11.9473 11.7946 12 11.685 12 11.5713V6.42871C12 6.31511 11.9472 6.20632 11.8535 6.12598C11.7597 6.04561 11.6326 6 11.5 6Z'
      fill='#CCCCCC'
      fillRule='evenodd'
    />
  </svg>

export const TestConfig = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M4.41675 2.33332C4.26204 2.33332 4.11367 2.39478 4.00427 2.50418C3.89487 2.61357 3.83341 2.76195 3.83341 2.91666V11.0833C3.83341 11.238 3.89487 11.3864 4.00427 11.4958C4.11367 11.6052 4.26204 11.6667 4.41675 11.6667H10.2501C10.4048 11.6667 10.5532 11.6052 10.6626 11.4958C10.772 11.3864 10.8334 11.238 10.8334 11.0833L10.8334 5.49161L7.67519 2.33339L4.41675 2.33332ZM3.17931 1.67922C3.5075 1.35103 3.95262 1.16666 4.41675 1.16666H7.67525C7.98461 1.16672 8.28141 1.28966 8.50014 1.50843M8.50014 1.50843L11.6582 4.66653C11.6582 4.66651 11.6583 4.66655 11.6582 4.66653C11.877 4.88527 12 5.182 12.0001 5.49136V11.0833C12.0001 11.5475 11.8157 11.9926 11.4875 12.3208C11.1593 12.6489 10.7142 12.8333 10.2501 12.8333H4.41675C3.95262 12.8333 3.5075 12.6489 3.17931 12.3208C2.85112 11.9926 2.66675 11.5475 2.66675 11.0833V2.91666C2.66675 2.45253 2.85112 2.00741 3.17931 1.67922M5.00008 6.99999C5.00008 6.67782 5.26125 6.41666 5.58342 6.41666H9.08342C9.40558 6.41666 9.66675 6.67782 9.66675 6.99999C9.66675 7.32216 9.40558 7.58332 9.08342 7.58332H5.58342C5.26125 7.58332 5.00008 7.32216 5.00008 6.99999ZM5.00008 9.33332C5.00008 9.01116 5.26125 8.74999 5.58342 8.74999H9.08342C9.40558 8.74999 9.66675 9.01116 9.66675 9.33332C9.66675 9.65549 9.40558 9.91666 9.08342 9.91666H5.58342C5.26125 9.91666 5.00008 9.65549 5.00008 9.33332Z'
      fill='#797979'
      fillRule='evenodd'
    />
  </svg>

export const MonitorConfig = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M4.41675 2.33332C4.26204 2.33332 4.11367 2.39478 4.00427 2.50418C3.89487 2.61357 3.83341 2.76195 3.83341 2.91666V11.0833C3.83341 11.238 3.89487 11.3864 4.00427 11.4958C4.11367 11.6052 4.26204 11.6667 4.41675 11.6667H10.2501C10.4048 11.6667 10.5532 11.6052 10.6626 11.4958C10.772 11.3864 10.8334 11.238 10.8334 11.0833L10.8334 5.49161L7.67519 2.33339L4.41675 2.33332ZM3.17931 1.67922C3.5075 1.35103 3.95262 1.16666 4.41675 1.16666H7.67525C7.98461 1.16672 8.28141 1.28966 8.50014 1.50843M8.50014 1.50843L11.6582 4.66653C11.877 4.88527 12 5.182 12.0001 5.49136V11.0833C12.0001 11.5475 11.8157 11.9926 11.4875 12.3208C11.1593 12.6489 10.7142 12.8333 10.2501 12.8333H4.41675C3.95262 12.8333 3.5075 12.6489 3.17931 12.3208C2.85112 11.9926 2.66675 11.5475 2.66675 11.0833V2.91666C2.66675 2.45253 2.85112 2.00741 3.17931 1.67922'
      fill='#797979'
      fillRule='evenodd'
    />
    <path
      d='M9.66675 7.96028C9.66675 8.02796 9.64341 8.09286 9.60187 8.14072C9.56033 8.18857 9.50399 8.21546 9.44524 8.21546H8.82877L8.15153 9.77567C8.13312 9.81803 8.10485 9.85366 8.06987 9.87856C8.03489 9.90346 7.99458 9.91665 7.95346 9.91666H7.94239C7.89943 9.91415 7.85804 9.89729 7.82326 9.86814C7.78849 9.83899 7.76183 9.7988 7.74654 9.75249L6.75365 6.75137L6.23533 8.0666C6.21765 8.11106 6.18924 8.14872 6.15351 8.17511C6.11777 8.2015 6.07621 8.21551 6.03376 8.21546H5.22159C5.16284 8.21546 5.1065 8.18857 5.06496 8.14072C5.02342 8.09286 5.00008 8.02796 5.00008 7.96028C5.00008 7.8926 5.02342 7.8277 5.06496 7.77984C5.1065 7.73199 5.16284 7.7051 5.22159 7.7051H5.89108L6.57054 5.98264C6.58866 5.93685 6.61813 5.89826 6.65523 5.87172C6.69234 5.84517 6.73543 5.83186 6.77909 5.83345C6.82274 5.83504 6.86502 5.85147 6.90059 5.88066C6.93617 5.90985 6.96346 5.95051 6.97903 5.99752L7.98097 9.02693L8.49375 7.84545C8.51223 7.8032 8.54053 7.76771 8.57551 7.74293C8.61048 7.71814 8.65075 7.70505 8.69181 7.7051L9.44524 7.7051C9.50399 7.7051 9.56033 7.73198 9.60187 7.77984C9.64341 7.8277 9.66675 7.8926 9.66675 7.96028Z'
      fill='#797979'
    />
    <path
      d='M7.74654 9.75249C7.76183 9.7988 7.78849 9.83899 7.82326 9.86814C7.84931 9.88996 7.87914 9.90494 7.91048 9.9121L7.94239 9.91666H7.95346L7.98397 9.91438C8.00421 9.91113 8.02393 9.90449 8.04264 9.89501L8.06987 9.87856C8.09607 9.85988 8.11873 9.83518 8.13607 9.80614L8.15153 9.77567L8.82877 8.21546H9.44524L9.48844 8.21052C9.51696 8.20399 9.54402 8.19096 9.5682 8.17235L9.60187 8.14072C9.6329 8.10492 9.65366 8.05944 9.66219 8.01057L9.66675 7.96028C9.66675 7.8926 9.64341 7.8277 9.60187 7.77984C9.57066 7.74389 9.53111 7.71955 9.48844 7.70979L9.44524 7.7051L9.44515 7.41356C9.57691 7.41356 9.69638 7.46652 9.78581 7.55085L9.82227 7.58845L9.85417 7.62947C9.92364 7.72706 9.95842 7.84436 9.95842 7.96044C9.95838 8.07655 9.92371 8.19382 9.85417 8.29141L9.82227 8.33186C9.74178 8.42458 9.62873 8.48917 9.50098 8.5039L9.44515 8.50731H9.02018L8.41919 9.89159C8.38134 9.97874 8.32057 10.058 8.23918 10.116C8.15721 10.1744 8.0582 10.2083 7.95378 10.2083H7.93384L7.92529 10.2078C7.81624 10.2014 7.7159 10.1586 7.63591 10.0915C7.55657 10.025 7.50055 9.93797 7.46956 9.84431L6.72957 7.60782L6.50684 8.17349L6.50627 8.17463C6.47916 8.2427 6.43846 8.3064 6.38493 8.35977L6.32682 8.4099C6.24349 8.47143 6.14175 8.50674 6.03402 8.50674L5.22168 8.50731C5.09 8.50731 4.97044 8.45428 4.88102 8.37003L4.84456 8.33186C4.77644 8.25334 4.73398 8.15819 4.71696 8.05956L4.70841 7.96044L4.71696 7.86075C4.73401 7.76216 4.77645 7.66692 4.84456 7.58845L4.88102 7.55085C4.97046 7.46651 5.08992 7.41356 5.22168 7.41356L5.22159 7.7051L5.17839 7.70979C5.13572 7.71955 5.09617 7.74389 5.06496 7.77984C5.02342 7.8277 5.00008 7.8926 5.00008 7.96028C5.00008 8.02796 5.02342 8.09286 5.06496 8.14072C5.09616 8.17667 5.13573 8.20075 5.17839 8.21052L5.22159 8.21546H6.03376C6.06556 8.21545 6.09702 8.20737 6.12573 8.19229L6.15351 8.17511C6.18026 8.15535 6.20319 8.12938 6.2203 8.09887L6.23533 8.0666L6.75365 6.75137L7.74654 9.75249ZM6.87142 5.55191C6.92431 5.56297 6.97439 5.58265 7.0201 5.60945L7.08561 5.65502L7.14201 5.70914C7.17663 5.74748 7.2053 5.79017 7.22746 5.8356L7.25594 5.90567L8.01758 8.20881L8.22607 7.72916L8.22664 7.72859L8.25911 7.66478C8.29607 7.60325 8.34558 7.548 8.40666 7.50471L8.4716 7.46597C8.53883 7.43211 8.6139 7.41348 8.69206 7.41356L8.69181 7.7051L8.6613 7.70751C8.63099 7.71233 8.60176 7.72433 8.57551 7.74293C8.54053 7.76771 8.51223 7.8032 8.49375 7.84545L7.98097 9.02693L6.97903 5.99752C6.96346 5.95051 6.93617 5.90985 6.90059 5.88066C6.86502 5.85147 6.82274 5.83504 6.77909 5.83345C6.73543 5.83186 6.69234 5.84517 6.65523 5.87172C6.61813 5.89826 6.58866 5.93685 6.57054 5.98264L5.89108 7.7051H5.22159L5.22168 7.41356H5.69279L6.29948 5.87548L6.33195 5.80712C6.3693 5.74063 6.42093 5.68089 6.48576 5.63451L6.55412 5.59293C6.62585 5.55722 6.70665 5.53919 6.78996 5.54223L6.87142 5.55191ZM9.44515 7.41356L9.44524 7.7051L8.69181 7.7051L8.69206 7.41356H9.44515Z'
      fill='#797979'
    />
  </svg>

export const CircledSpace = ({ size = '23' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_3140_75756)'>
      <circle
        cx='11.75'
        cy='11.3164'
        fill='white'
        r='11.25'
      />
      <path
        color='#3F2B56'
        d='M12.6071 16.9004C12.6072 17.0363 12.6446 17.17 12.7158 17.2887C12.7869 17.4074 12.8895 17.5072 13.0138 17.5786C13.138 17.65 13.2798 17.6907 13.4257 17.6969C13.5716 17.703 13.7168 17.6743 13.8474 17.6135L17.276 16.0182C17.4184 15.952 17.5381 15.8502 17.6218 15.7242C17.7055 15.5983 17.7499 15.4531 17.75 15.305V10.7072C17.7499 10.5713 17.7125 10.4376 17.6414 10.3189C17.5702 10.2002 17.4676 10.1004 17.3434 10.029C17.2191 9.95755 17.0773 9.91684 16.9314 9.91072C16.7855 9.90461 16.6404 9.93329 16.5097 9.99404L13.0811 11.5894C12.9388 11.6556 12.819 11.7574 12.7353 11.8833C12.6516 12.0093 12.6072 12.1544 12.6071 12.3025V16.9004ZM16.2166 8.34602C16.3588 8.27971 16.4783 8.17788 16.5619 8.05194C16.6454 7.926 16.6897 7.7809 16.6897 7.63289C16.6897 7.48488 16.6454 7.33979 16.5619 7.21385C16.4783 7.08791 16.3588 6.98608 16.2166 6.91976L12.1331 5.01968C12.0142 4.96435 11.883 4.93555 11.75 4.93555C11.617 4.93555 11.4858 4.96435 11.3669 5.01968L7.28343 6.91976C7.14124 6.98608 7.02169 7.08791 6.93814 7.21385C6.85459 7.33979 6.81034 7.48488 6.81034 7.63289C6.81034 7.7809 6.85459 7.926 6.93814 8.05194C7.02169 8.17788 7.14124 8.27971 7.28343 8.34602L11.3669 10.2461C11.4858 10.3014 11.617 10.3302 11.75 10.3302C11.883 10.3302 12.0142 10.3014 12.1331 10.2461L16.2166 8.34602ZM6.99029 9.99404C6.85964 9.93329 6.71448 9.90461 6.56858 9.91072C6.42268 9.91684 6.28087 9.95755 6.15662 10.029C6.03238 10.1004 5.9298 10.2002 5.85864 10.3189C5.78747 10.4376 5.75008 10.5713 5.75 10.7072V15.305C5.75008 15.4531 5.79447 15.5983 5.87819 15.7242C5.9619 15.8502 6.08165 15.952 6.224 16.0182L9.65257 17.6135C9.78322 17.6743 9.92838 17.703 10.0743 17.6969C10.2202 17.6907 10.362 17.65 10.4862 17.5786C10.6105 17.5072 10.7131 17.4074 10.7842 17.2887C10.8554 17.17 10.8928 17.0363 10.8929 16.9004V12.3025C10.8928 12.1544 10.8484 12.0093 10.7647 11.8833C10.681 11.7574 10.5612 11.6556 10.4189 11.5894L6.99029 9.99404Z'
      />
    </g>
    <defs>
      <clipPath id='clip0_3140_75756'>
        <rect
          fill='white'
          height={size}
          transform='translate(0.5 0.0664062)'
          width={size}
        />
      </clipPath>
    </defs>
  </svg>

export const TestStatus = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 22 22'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M10.4608 3.07451C10.6139 3.60514 10.3079 4.15944 9.77725 4.31256C6.43951 5.2757 4 8.35426 4 12C4 13.646 4.49602 15.1731 5.34655 16.4437C5.65377 16.9027 5.53076 17.5238 5.0718 17.831C4.61285 18.1382 3.99175 18.0152 3.68454 17.5562C2.62052 15.9667 2 14.0543 2 12C2 7.43954 5.05192 3.59451 9.22275 2.39096C9.75338 2.23784 10.3077 2.54388 10.4608 3.07451ZM13.6604 3.0961C13.8208 2.56762 14.3793 2.26921 14.9078 2.42959C18.1363 3.40936 20.672 5.97555 21.609 9.22277C21.7622 9.7534 21.4561 10.3077 20.9255 10.4608C20.3949 10.6139 19.8406 10.3079 19.6874 9.77726C18.9385 7.1818 16.908 5.12667 14.327 4.34341C13.7985 4.18303 13.5001 3.62459 13.6604 3.0961ZM20.9255 13.5392C21.4561 13.6923 21.7622 14.2466 21.609 14.7772C20.4055 18.9481 16.5605 22 12 22C10.4053 22 8.89511 21.626 7.55497 20.96C7.06039 20.7142 6.8587 20.114 7.10449 19.6194C7.35027 19.1249 7.95045 18.9232 8.44503 19.169C9.5148 19.7006 10.721 20 12 20C15.6457 20 18.7243 17.5605 19.6874 14.2227C19.8406 13.6921 20.3949 13.3861 20.9255 13.5392Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
  </svg>

export const Stop = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      fill='var(--stop-icon-color)'
      height='16.0926'
      rx='2.5'
      width='16.0926'
      x='3.95368'
      y='3.95367'
    />
  </svg>

export const ApplyToAll = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V14C5 14.2652 5.10536 14.5196 5.29289 14.7071C5.48043 14.8946 5.73478 15 6 15H7V10C7 9.20435 7.31607 8.44129 7.87868 7.87868C8.44129 7.31607 9.20435 7 10 7H15V6C15 5.73478 14.8946 5.48043 14.7071 5.29289C14.5196 5.10536 14.2652 5 14 5H6ZM17 7V6C17 5.20435 16.6839 4.44129 16.1213 3.87868C15.5587 3.31607 14.7956 3 14 3H6C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6V14C3 14.7956 3.31607 15.5587 3.87868 16.1213C4.44129 16.6839 5.20435 17 6 17H7V18C7 18.7957 7.31607 19.5587 7.87868 20.1213C8.44129 20.6839 9.20435 21 10 21H18C18.7957 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7957 21 18V10C21 9.20435 20.6839 8.44129 20.1213 7.87868C19.5587 7.31607 18.7957 7 18 7H17ZM10 9C9.73478 9 9.48043 9.10536 9.29289 9.29289C9.10536 9.48043 9 9.73478 9 10V18C9 18.2652 9.10536 18.5196 9.29289 18.7071C9.48043 18.8946 9.73478 19 10 19H18C18.2652 19 18.5196 18.8946 18.7071 18.7071C18.8946 18.5196 19 18.2652 19 18V10C19 9.73478 18.8946 9.48043 18.7071 9.29289C18.5196 9.10536 18.2652 9 18 9H10Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
    <path
      d='M17.4142 11.7929C17.8047 12.1834 17.8047 12.8166 17.4142 13.2071L14.1213 16.5C13.7308 16.8905 13.0976 16.8905 12.7071 16.5L11 14.7929C10.6095 14.4024 10.6095 13.7692 11 13.3787C11.3905 12.9881 12.0237 12.9881 12.4142 13.3787L13.4142 14.3787L16 11.7929C16.3905 11.4024 17.0237 11.4024 17.4142 11.7929Z'
      fill='var(--icon)'
    />
  </svg>

export const MoveAll = ({ size = '16' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 12 15'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M9.30815 4.51404C8.85952 4.73835 8.85952 5.37858 9.30815 5.60289L9.50852 5.70308L6.00007 7.4573L2.49163 5.70308L2.69197 5.60291C3.14061 5.37859 3.14061 4.73836 2.69197 4.51405C2.52061 4.42837 2.31891 4.42837 2.14754 4.51405L0.87013 5.15276C0.691959 5.29218 0.775207 5.19756 0.612548 5.38327C0.570088 5.43175 0.55319 5.49866 0.538012 5.5632C0.52702 5.60959 0.521693 5.65652 0.521729 5.70308L0.521862 5.71627V11.79C0.521862 12.0205 0.652123 12.2313 0.858338 12.3344L5.71689 14.7637C5.7617 14.7873 5.80981 14.8054 5.86035 14.8173C5.90669 14.8283 5.95356 14.8336 6.00007 14.8336C6.04658 14.8336 6.09345 14.8283 6.13977 14.8173C6.17428 14.8092 6.20849 14.7979 6.24202 14.7833C6.25434 14.778 6.27131 14.7698 6.28327 14.7637L11.1418 12.3344C11.348 12.2313 11.4783 12.0205 11.4783 11.79V5.71626L11.4784 5.70308C11.4785 5.65656 11.4731 5.60968 11.4622 5.56334C11.447 5.4987 11.4215 5.43803 11.3875 5.38315C11.3627 5.34284 11.333 5.30521 11.2988 5.27124C11.2655 5.23818 11.2289 5.20941 11.1896 5.18522C11.1704 5.17334 11.1506 5.16249 11.13 5.15276L9.85258 4.51404C9.68122 4.42836 9.47952 4.42836 9.30815 4.51404ZM1.73924 11.4138V6.68796L5.39138 8.51403V13.2399L1.73924 11.4138ZM6.60876 13.2399V8.51403L10.2609 6.68796V11.4138L6.60876 13.2399Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
    <path
      clipRule='evenodd'
      d='M6.00005 5.70264C5.66388 5.70264 5.39136 5.43012 5.39136 5.09395L5.39136 2.91131L4.60439 3.69828C4.36668 3.93599 3.98128 3.93599 3.74358 3.69828C3.50587 3.46058 3.50587 3.07518 3.74358 2.83747L5.56921 1.01183C5.57068 1.01036 5.57215 1.0089 5.57364 1.00744C5.68306 0.900012 5.83289 0.833604 5.99823 0.833118L6.00005 0.833116L6.00188 0.833118C6.08375 0.833359 6.16181 0.849761 6.23305 0.879303C6.30321 0.908332 6.36905 0.951044 6.42647 1.00744C6.42795 1.0089 6.42943 1.01036 6.4309 1.01183L8.25653 2.83747C8.49424 3.07518 8.49424 3.46058 8.25653 3.69829C8.01883 3.93599 7.63342 3.93599 7.39572 3.69829L6.60874 2.91131L6.60874 5.09395C6.60874 5.43012 6.33622 5.70264 6.00005 5.70264Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
  </svg>

export const TestConfigSut = ({ size = '16' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clipRule='evenodd'
      d='M2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7957 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V15C22 15.7957 21.6839 16.5587 21.1213 17.1213C20.5587 17.6839 19.7957 18 19 18H15.5308L15.903 19.4888L16.7071 20.2929C16.9931 20.5789 17.0787 21.009 16.9239 21.3827C16.7691 21.7564 16.4045 22 16 22H8C7.59554 22 7.2309 21.7564 7.07612 21.3827C6.92134 21.009 7.0069 20.5789 7.29289 20.2929L8.09704 19.4888L8.46922 18H5C4.20435 18 3.44129 17.6839 2.87868 17.1213C2.31607 16.5587 2 15.7956 2 15V5C2 4.20435 2.31607 3.44129 2.87868 2.87868ZM4 14V15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H9.72757C9.74198 15.9997 9.75643 15.9997 9.77092 16H14.2291C14.2436 15.9997 14.258 15.9997 14.2724 16H19C19.2652 16 19.5196 15.8946 19.7071 15.7071C19.8946 15.5196 20 15.2652 20 15V14H4ZM20 12H4V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V12ZM13.4692 18H10.5308L10.0308 20H13.9692L13.4692 18Z'
      fill='var(--icon)'
      fillRule='evenodd'
    />
  </svg>

export const Union = ({ size = '18' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 18 18'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.1387 8.39648C16.5668 8.60078 17.5806 9.90864 17.3672 11.3428C17.1535 12.7768 15.8011 13.7462 14.373 13.542C14.1841 13.5149 14.0026 13.4677 13.8301 13.4043C12.3521 14.7975 10.2608 15.5303 8.08203 15.2188C5.1686 14.802 2.94386 12.642 2.35938 9.95996C2.27154 9.55615 2.52866 9.15556 2.93359 9.06543C3.33855 8.97556 3.73813 9.23001 3.82617 9.63379C4.27935 11.7135 6.01253 13.4077 8.30273 13.7354C9.92324 13.9671 11.4755 13.464 12.6143 12.4883C12.2299 11.9625 12.0415 11.2944 12.1455 10.5957C12.3592 9.16181 13.7108 8.19256 15.1387 8.39648ZM14.918 9.87988C14.2833 9.78933 13.7187 10.2199 13.6309 10.8076C13.5433 11.3957 13.9588 11.9676 14.5938 12.0586C15.2289 12.1494 15.7943 11.718 15.8818 11.1299C15.9692 10.5419 15.5529 9.97072 14.918 9.87988ZM4.31348 2.38477C5.79151 0.991152 7.8843 0.259605 10.0635 0.571289C12.977 0.98808 15.2017 3.14793 15.7861 5.83008C15.8739 6.23385 15.6168 6.63353 15.2119 6.72363C14.8069 6.81367 14.4075 6.56004 14.3193 6.15625C13.8662 4.07654 12.133 2.38238 9.84277 2.05469C8.22216 1.8229 6.66812 2.324 5.5293 3.2998C5.9146 3.82592 6.1032 4.49469 5.99902 5.19434C5.78522 6.6282 4.43377 7.59769 3.00586 7.39355C1.57798 7.18908 0.564961 5.88126 0.77832 4.44727C0.991874 3.01306 2.34432 2.04283 3.77246 2.24707C3.96076 2.27402 4.14149 2.32168 4.31348 2.38477ZM3.55176 3.73145C2.91684 3.64062 2.3515 4.07133 2.26367 4.65918C2.17626 5.24721 2.59253 5.81834 3.22754 5.90918C3.86235 5.99972 4.42698 5.56928 4.51465 4.98145C4.60203 4.39356 4.18651 3.82249 3.55176 3.73145Z'
      fill='var(--icon)'
    />
  </svg>

export const TestToolsBold = ({ size = '14' }: IconInterface) =>
  <svg
    height={size}
    viewBox='0 0 14 14'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.2,8.2v-2.5c.7-.2,1.3-.9,1.3-1.7s-.8-1.8-1.8-1.8-.9.2-1.2.5l-1.7-.8c0,0,0-.2,0-.3,0-1-.8-1.8-1.8-1.8s-1.8.8-1.8,1.8,0,.2,0,.3l-1.7.8c-.3-.3-.8-.5-1.2-.5-1,0-1.8.8-1.8,1.8s.5,1.5,1.2,1.7v2.5c-.7.2-1.2.9-1.2,1.7s.8,1.8,1.8,1.8,1-.3,1.4-.7l1.6.9c0,.1,0,.2,0,.4,0,1,.8,1.8,1.8,1.8s1.8-.8,1.8-1.8,0-.2,0-.4l1.6-.9c.3.4.8.7,1.4.7,1,0,1.8-.8,1.8-1.8s-.5-1.5-1.3-1.7ZM8.2,11c-.3-.3-.8-.5-1.2-.5s-.9.2-1.2.5l-1.7-.9c0,0,0-.1,0-.2,0-.8-.5-1.5-1.2-1.7v-2.5c.7-.2,1.2-.9,1.2-1.7s0-.2,0-.3l1.7-.8c.3.3.8.6,1.3.6s1-.2,1.3-.6l1.7.8c0,.1,0,.2,0,.3,0,.8.5,1.5,1.2,1.7v2.5c-.7.2-1.2.9-1.2,1.7s0,.1,0,.2l-1.7.9Z'
      fill='currentColor'
    />
    <path
      d='M7,4.7c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3,2.3-1,2.3-2.3-1-2.3-2.3-2.3Z'
      fill='currentColor'
    />
  </svg>

export const TestTools = ({ size = '14' }: IconInterface) =>
  <svg
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14 3C14 4.10457 13.1046 5 12 5C10.8954 5 10 4.10457 10 3C10 1.89543 10.8954 1 12 1C13.1046 1 14 1.89543 14 3Z'
      fill='currentColor'
    />
    <path
      d='M6 7C6 8.10457 5.10457 9 4 9C2.89543 9 2 8.10457 2 7C2 5.89543 2.89543 5 4 5C5.10457 5 6 5.89543 6 7Z'
      fill='currentColor'
    />
    <path
      d='M22 7C22 8.10457 21.1046 9 20 9C18.8954 9 18 8.10457 18 7C18 5.89543 18.8954 5 20 5C21.1046 5 22 5.89543 22 7Z'
      fill='currentColor'
    />
    <path
      d='M6 16C6 17.1046 5.10457 18 4 18C2.89543 18 2 17.1046 2 16C2 14.8954 2.89543 14 4 14C5.10457 14 6 14.8954 6 16Z'
      fill='currentColor'
    />
    <path
      d='M22 16C22 17.1046 21.1046 18 20 18C18.8954 18 18 17.1046 18 16C18 14.8954 18.8954 14 20 14C21.1046 14 22 14.8954 22 16Z'
      fill='currentColor'
    />
    <path
      d='M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z'
      fill='currentColor'
    />
    <path
      d='M14 21C14 22.1046 13.1046 23 12 23C10.8954 23 10 22.1046 10 21C10 19.8954 10.8954 19 12 19C13.1046 19 14 19.8954 14 21Z'
      fill='currentColor'
    />
    <path
      clipRule='evenodd'
      d='M20.75 6.42188V17.0664L12 21.8535L3.25 17.0664V6.42188L12 2.16504L20.75 6.42188ZM11.8906 3.88672L4.75 7.36035V16.1768L4.87988 16.248L11.8799 20.0791L12 20.1445L12.1201 20.0791L19.1201 16.248L19.25 16.1768V7.36035L12.1094 3.88672L12 3.83301L11.8906 3.88672Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>

export const Integration = ({ size = '14' }: IconInterface) =>
  <svg
    fill='currentColor'
    height={size}
    viewBox='0 0 22.5 22.5'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M11.2,0C5,0,0,5,0,11.2s5,11.2,11.2,11.2,11.2-5,11.2-11.2S17.5,0,11.2,0ZM7,5.6c.7,0,1.4.5,1.6,1.2-.8.5-1.5,1.2-1.9,2.1h0c-.8-.1-1.4-.8-1.4-1.6s1-1.7,1.7-1.7ZM7,17.6c-.9,0-1.7-.8-1.7-1.7s.7-1.7,1.6-1.7c.5.7,1.1,1.4,1.8,1.8,0,.9-.8,1.6-1.7,1.6ZM7.2,11.4c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2-1.9,4.2-4.2,4.2-4.2-1.9-4.2-4.2ZM15.7,17.5c-.9,0-1.6-.6-1.7-1.4.8-.4,1.6-1.1,2.1-1.9h.1c.7.2,1.2.8,1.2,1.6s-.8,1.7-1.7,1.7ZM16.3,8.8c-.5-.9-1.2-1.7-2.2-2.2.3-.7.9-1.1,1.6-1.1s1.7,1,1.7,1.7-.5,1.3-1.1,1.6Z' />
  </svg>

export const CustomScriptsLayer = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 15 15'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_6577_24637)'>
      <path
        d='M7.33289 14.6667C6.39307 14.6667 5.61341 14.0533 5.39165 13.1408C5.35821 13.0026 5.27285 12.8865 5.1523 12.8125C5.03086 12.7386 4.8883 12.7166 4.75103 12.7501C4.69735 12.7633 4.64631 12.7844 4.59967 12.8125C3.79712 13.3018 2.81154 13.1839 2.14716 12.5195C1.48277 11.8551 1.36485 10.8695 1.85324 10.0679C2.00548 9.81796 1.92628 9.49061 1.67637 9.33837C1.62973 9.31021 1.57869 9.28909 1.52589 9.2759C0.613348 9.05238 0 8.27271 0 7.33289C0 6.39307 0.613348 5.61341 1.52589 5.39165C1.811 5.32301 1.98612 5.03526 1.91748 4.75014C1.90428 4.69647 1.88316 4.64543 1.855 4.59879C1.36661 3.79624 1.48453 2.81154 2.14804 2.14716C2.81242 1.48277 3.798 1.36485 4.59967 1.85324C4.74662 1.943 4.92086 1.9562 5.07838 1.89108C5.23678 1.82596 5.35117 1.69221 5.39165 1.52589C5.61341 0.613348 6.39395 0 7.33289 0C8.27271 0 9.05238 0.613348 9.27413 1.52589C9.34277 1.811 9.63141 1.98612 9.91564 1.9166C9.96932 1.9034 10.0204 1.88228 10.067 1.85412C10.8695 1.36573 11.8542 1.48365 12.5186 2.14716C13.183 2.81154 13.3009 3.79712 12.8125 4.59967C12.7386 4.72111 12.7166 4.86366 12.7501 5.00094C12.7835 5.1391 12.8689 5.25526 12.9894 5.32917C13.0361 5.35733 13.0871 5.37845 13.1399 5.39165C14.0524 5.61341 14.6658 6.39307 14.6658 7.33289C14.6658 8.27271 14.0524 9.05238 13.1399 9.27413C13.0017 9.30757 12.8856 9.39293 12.8117 9.51349C12.7377 9.63493 12.7157 9.77748 12.7492 9.91476C12.7624 9.96844 12.7835 10.0195 12.8117 10.0661C13.3001 10.8687 13.1821 11.8534 12.5186 12.5177C11.8542 13.1821 10.8687 13.3001 10.067 12.8117C9.81708 12.6594 9.48973 12.7386 9.33749 12.9885C9.30933 13.0352 9.28821 13.0862 9.27501 13.1399C9.05414 14.0524 8.27359 14.6649 7.33465 14.6649L7.33289 14.6667ZM4.8795 11.2664C5.24206 11.2664 5.59845 11.3659 5.91612 11.5594C6.37195 11.8375 6.69139 12.2758 6.81722 12.7941C6.90874 13.1698 7.23522 13.1989 7.33289 13.1989C7.43057 13.1989 7.75705 13.1698 7.84856 12.7932C7.89784 12.5917 7.97704 12.4016 8.08352 12.2256C8.65639 11.2849 9.88748 10.9857 10.8282 11.5586C11.1591 11.7601 11.4107 11.5498 11.4803 11.4803C11.5498 11.4107 11.7601 11.1591 11.5586 10.8282C11.4512 10.6513 11.372 10.4604 11.3227 10.2597C11.0631 9.18878 11.7231 8.10728 12.7941 7.84768C13.1698 7.75617 13.1989 7.42969 13.1989 7.33201C13.1989 7.23434 13.1698 6.90786 12.7932 6.81634C12.5925 6.76794 12.4016 6.68875 12.2256 6.58139C11.7698 6.30419 11.4495 5.86508 11.3236 5.34677C11.1978 4.82846 11.2814 4.29167 11.5586 3.83584C11.7601 3.50497 11.5498 3.25329 11.4803 3.18378C11.4107 3.11426 11.1591 2.90394 10.8282 3.10546C10.6513 3.21282 10.4604 3.29201 10.2588 3.34129C9.18878 3.60089 8.1064 2.9409 7.8468 1.86996C7.75528 1.49421 7.42881 1.46517 7.33113 1.46517C7.23346 1.46517 6.90698 1.49421 6.81546 1.87084C6.66323 2.49739 6.2338 2.99898 5.63805 3.24538C5.0423 3.49177 4.38495 3.44073 3.83496 3.10458C3.50497 2.90306 3.25241 3.11426 3.18378 3.1829C3.11426 3.25241 2.90394 3.50409 3.10546 3.83496C3.21282 4.01096 3.29201 4.2028 3.34129 4.40431C3.60089 5.47525 2.9409 6.55675 1.86996 6.81634C1.49421 6.90786 1.46517 7.23434 1.46517 7.33201C1.46517 7.42969 1.49421 7.75617 1.87084 7.84768C2.07148 7.89608 2.26243 7.97528 2.43843 8.08264C3.37913 8.65551 3.67833 9.88748 3.10546 10.8282C2.90394 11.1591 3.11426 11.4107 3.18378 11.4803C3.25329 11.5498 3.50497 11.7601 3.83584 11.5586C4.01184 11.4512 4.20368 11.372 4.40519 11.3227C4.56271 11.2849 4.72111 11.2655 4.8795 11.2655V11.2664Z'
        fill='var(--icon)'
      />
      <path
        d='M9.33982 6.97852L6.45879 5.19023C6.2247 5.045 5.86621 5.18593 5.86621 5.54514V9.12085C5.86621 9.4431 6.19933 9.63732 6.45879 9.47576L9.33982 7.68833C9.59682 7.52935 9.59764 7.13749 9.33982 6.97852Z'
        fill='var(--icon)'
      />
    </g>
    <defs>
      <clipPath id='clip0_6577_24637'>
        <rect
          fill='var(--icon)'
          height='14.6667'
          width='14.6667'
        />
      </clipPath>
    </defs>
  </svg>

export const TestConfigTag = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 16 16'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.00071 15.0289C7.46086 15.0289 6.92101 14.8231 6.50937 14.4123L1.58913 9.49204C1.1969 9.09981 0.97168 8.55574 0.97168 8.00071V4.48661C0.97168 2.54821 2.54821 0.97168 4.48661 0.97168H8.00492C8.55912 0.97168 9.1015 1.1969 9.49289 1.59082L14.4123 6.51021C15.2347 7.33264 15.2347 8.67046 14.4123 9.49204L9.49205 14.4123C9.08125 14.8231 8.5414 15.0289 8.00071 15.0289ZM4.48661 2.37782C3.32341 2.37782 2.37782 3.3234 2.37782 4.48661V8.00155C2.37782 8.18712 2.4529 8.36764 2.5828 8.49754L7.50388 13.4186C7.77802 13.6928 8.2234 13.6928 8.49754 13.4186L13.4178 8.49838C13.6919 8.22424 13.6919 7.77886 13.4178 7.50472L8.49754 2.58448C8.36679 2.4529 8.18712 2.37867 8.00324 2.37867H4.48577L4.48661 2.37782ZM4.49336 5.18926C4.10535 5.18926 3.7865 4.87463 3.7865 4.48661C3.7865 4.0986 4.09775 3.78397 4.48577 3.78397H4.49252C4.88054 3.78397 5.19517 4.0986 5.19517 4.48661C5.19517 4.87463 4.88054 5.18926 4.49252 5.18926H4.49336Z'
      fill='var(--icon)'
    />
    <path
      clip-rule='evenodd'
      d='M5.60617 9.02316C5.34582 8.76281 5.32088 8.36564 5.55046 8.13606L8.04466 5.64186C8.27424 5.41228 8.67141 5.43722 8.93176 5.69757C9.19211 5.95792 9.21705 6.35509 8.98747 6.58467L6.49327 9.07887C6.26369 9.30845 5.86652 9.28351 5.60617 9.02316ZM7.49179 10.9088C7.23144 10.6484 7.2065 10.2513 7.43608 10.0217L9.93028 7.52748C10.1599 7.2979 10.557 7.32284 10.8174 7.58319C11.0777 7.84354 11.1027 8.24071 10.8731 8.47029L8.37889 10.9645C8.14931 11.1941 7.75214 11.1691 7.49179 10.9088Z'
      fill='var(--icon)'
      fill-rule='evenodd'
    />
  </svg>

export const SutTag = ({ size = '14' }: IconInterface) =>
  <svg
    fill='none'
    height={size}
    viewBox='0 0 16 16'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.00071 15.0289C7.46086 15.0289 6.92101 14.8231 6.50937 14.4123L1.58913 9.49204C1.1969 9.09981 0.97168 8.55574 0.97168 8.00071V4.48661C0.97168 2.54821 2.54821 0.97168 4.48661 0.97168H8.00492C8.55912 0.97168 9.1015 1.1969 9.49289 1.59082L14.4123 6.51021C15.2347 7.33264 15.2347 8.67046 14.4123 9.49204L9.49205 14.4123C9.08125 14.8231 8.5414 15.0289 8.00071 15.0289ZM4.48661 2.37782C3.32341 2.37782 2.37782 3.3234 2.37782 4.48661V8.00155C2.37782 8.18712 2.4529 8.36764 2.5828 8.49754L7.50388 13.4186C7.77802 13.6928 8.2234 13.6928 8.49754 13.4186L13.4178 8.49838C13.6919 8.22424 13.6919 7.77886 13.4178 7.50472L8.49754 2.58448C8.36679 2.4529 8.18712 2.37867 8.00324 2.37867H4.48577L4.48661 2.37782ZM4.49336 5.18926C4.10535 5.18926 3.7865 4.87463 3.7865 4.48661C3.7865 4.0986 4.09775 3.78397 4.48577 3.78397H4.49252C4.88054 3.78397 5.19517 4.0986 5.19517 4.48661C5.19517 4.87463 4.88054 5.18926 4.49252 5.18926H4.49336Z'
      fill='var(--icon)'
    />
    <path
      d='M7.8724 5.5485C8.00363 5.41727 8.18193 5.34346 8.36751 5.34341C8.55312 5.34341 8.73136 5.41729 8.86263 5.5485L10.1118 6.81148C10.2428 6.94261 10.3161 7.12057 10.3162 7.30591C10.3162 7.49151 10.2423 7.66975 10.1111 7.80102L9.53866 8.37347L10.0648 8.78089L10.3307 8.78158C10.4248 8.78176 10.5101 8.83825 10.5461 8.92521C10.5822 9.01233 10.5624 9.11328 10.4957 9.18002L9.17544 10.5003C9.10874 10.5668 9.00839 10.586 8.92132 10.55C8.83429 10.514 8.77721 10.4294 8.777 10.3353L8.77631 10.0694L8.37373 9.5384L7.80128 10.1109C7.67 10.2421 7.49181 10.3159 7.30616 10.3159C7.12074 10.3159 6.94292 10.2426 6.81174 10.1115L5.56257 8.84856C5.43135 8.71729 5.35748 8.53905 5.35748 8.35345C5.35749 8.16784 5.43133 7.98959 5.56257 7.85833L7.8724 5.5485ZM5.89264 8.18841C5.84892 8.23215 5.82429 8.2916 5.82428 8.35345C5.82428 8.41528 5.84895 8.47474 5.89264 8.51848L6.31939 8.95352L6.31663 8.95628L7.14182 9.78147C7.18555 9.82507 7.24509 9.84983 7.30685 9.84983C7.36859 9.84973 7.42823 9.82514 7.47189 9.78147L9.78173 7.47163C9.82539 7.42792 9.85005 7.36838 9.85009 7.3066C9.85009 7.24483 9.82532 7.18529 9.78173 7.14156L9.28661 6.64645L8.53255 5.87857C8.4888 5.83488 8.42935 5.81021 8.36751 5.81021C8.3057 5.81026 8.24619 5.83486 8.20248 5.87857L5.89264 8.18841Z'
      fill='var(--icon)'
    />
    <path
      d='M8.36751 5.34341L8.36751 4.84341L8.36738 4.84341L8.36751 5.34341ZM8.86263 5.5485L9.21812 5.19689L9.21611 5.19487L8.86263 5.5485ZM10.1118 6.81148L9.75631 7.16309L9.75806 7.16485L10.1118 6.81148ZM10.3162 7.30591L10.8162 7.30591L10.8162 7.30553L10.3162 7.30591ZM10.1111 7.80102L10.4647 8.15457L10.4647 8.15451L10.1111 7.80102ZM9.53866 8.37347L9.18511 8.01992C9.08356 8.12146 9.03058 8.26177 9.03966 8.40509C9.04874 8.5484 9.119 8.6809 9.23255 8.76882L9.53866 8.37347ZM10.0648 8.78089L9.75874 9.17623C9.84601 9.2438 9.95318 9.2806 10.0635 9.28089L10.0648 8.78089ZM10.3307 8.78158L10.3294 9.28158L10.3297 9.28158L10.3307 8.78158ZM10.5461 8.92521L11.0081 8.73387L11.0079 8.73351L10.5461 8.92521ZM10.4957 9.18002L10.8493 9.53357L10.8496 9.53324L10.4957 9.18002ZM9.17544 10.5003L9.52854 10.8543L9.52899 10.8539L9.17544 10.5003ZM8.92132 10.55L8.72998 11.012L8.73029 11.0121L8.92132 10.55ZM8.777 10.3353L9.277 10.3342L9.277 10.334L8.777 10.3353ZM8.77631 10.0694L9.27631 10.0681C9.27603 9.9595 9.24038 9.85392 9.17475 9.76735L8.77631 10.0694ZM8.37373 9.5384L8.77217 9.23633C8.68488 9.12119 8.55204 9.04944 8.40788 9.03957C8.26373 9.0297 8.12235 9.08268 8.02018 9.18485L8.37373 9.5384ZM7.30616 10.3159L7.30595 10.8159L7.30616 10.8159L7.30616 10.3159ZM6.81174 10.1115L6.45624 10.4632L6.45837 10.4653L6.81174 10.1115ZM5.56257 8.84856L5.91806 8.49695L5.91619 8.49508L5.56257 8.84856ZM5.35748 8.35345L4.85748 8.3534L4.85748 8.35345H5.35748ZM5.56257 7.85833L5.20901 7.50478L5.20898 7.50481L5.56257 7.85833ZM5.89264 8.18841L5.53909 7.83486L5.53901 7.83494L5.89264 8.18841ZM5.82428 8.35345L5.32428 8.35331V8.35345L5.82428 8.35345ZM5.89264 8.51848L6.24959 8.16833L6.24641 8.16515L5.89264 8.51848ZM6.31939 8.95352L6.67294 9.30707C6.86688 9.11314 6.86839 8.79917 6.67633 8.60338L6.31939 8.95352ZM6.31663 8.95628L5.96307 8.60273C5.76781 8.79799 5.76781 9.11457 5.96307 9.30984L6.31663 8.95628ZM7.14182 9.78147L6.78826 10.135L6.78882 10.1356L7.14182 9.78147ZM7.30685 9.84983L7.30685 10.3498L7.3077 10.3498L7.30685 9.84983ZM9.78173 7.47163L10.1353 7.82519L10.1355 7.82499L9.78173 7.47163ZM9.85009 7.3066L10.3501 7.30695V7.3066L9.85009 7.3066ZM9.78173 7.14156L10.1358 6.78856L10.1353 6.78801L9.78173 7.14156ZM9.28661 6.64645L8.92985 6.99679L8.93306 7L9.28661 6.64645ZM8.53255 5.87857L8.88932 5.52823L8.88588 5.5248L8.53255 5.87857ZM8.36751 5.81021L8.36751 5.31021L8.36711 5.31021L8.36751 5.81021ZM7.8724 5.5485L8.22595 5.90205C8.26336 5.86465 8.31449 5.84342 8.36765 5.84341L8.36751 5.34341L8.36738 4.84341C8.04937 4.84349 7.74391 4.96988 7.51885 5.19494L7.8724 5.5485ZM8.36751 5.34341L8.36751 5.84341C8.42042 5.84341 8.47156 5.86455 8.50915 5.90212L8.86263 5.5485L9.21611 5.19487C8.99117 4.97002 8.68581 4.84341 8.36751 4.84341L8.36751 5.34341ZM8.86263 5.5485L8.50714 5.9001L9.75631 7.16309L10.1118 6.81148L10.4673 6.45988L9.21812 5.19689L8.86263 5.5485ZM10.1118 6.81148L9.75806 7.16485C9.79489 7.20172 9.81616 7.25248 9.8162 7.30628L10.3162 7.30591L10.8162 7.30553C10.816 6.98866 10.6907 6.68351 10.4655 6.45812L10.1118 6.81148ZM10.3162 7.30591H9.8162C9.8162 7.35883 9.79506 7.40995 9.75749 7.44753L10.1111 7.80102L10.4647 8.15451C10.6896 7.92956 10.8162 7.6242 10.8162 7.30591H10.3162ZM10.1111 7.80102L9.75756 7.44747L9.18511 8.01992L9.53866 8.37347L9.89221 8.72703L10.4647 8.15457L10.1111 7.80102ZM9.53866 8.37347L9.23255 8.76882L9.75874 9.17623L10.0648 8.78089L10.371 8.38554L9.84477 7.97813L9.53866 8.37347ZM10.0648 8.78089L10.0635 9.28089L10.3294 9.28158L10.3307 8.78158L10.332 8.28158L10.0661 8.28089L10.0648 8.78089ZM10.3307 8.78158L10.3297 9.28158C10.224 9.28137 10.1263 9.21801 10.0844 9.11691L10.5461 8.92521L11.0079 8.73351C10.8938 8.45849 10.6257 8.28214 10.3317 8.28158L10.3307 8.78158ZM10.5461 8.92521L10.0842 9.11655C10.0432 9.01759 10.0653 8.90352 10.1419 8.82679L10.4957 9.18002L10.8496 9.53324C11.0594 9.32304 11.1213 9.00707 11.0081 8.73387L10.5461 8.92521ZM10.4957 9.18002L10.1422 8.82646L8.82189 10.1468L9.17544 10.5003L9.52899 10.8539L10.8493 9.53357L10.4957 9.18002ZM9.17544 10.5003L8.82234 10.1463C8.90086 10.068 9.01586 10.0481 9.11235 10.088L8.92132 10.55L8.73029 11.0121C9.00091 11.124 9.31662 11.0657 9.52854 10.8543L9.17544 10.5003ZM8.92132 10.55L9.11266 10.0881C9.21048 10.1286 9.27676 10.2248 9.277 10.3342L8.777 10.3353L8.277 10.3364C8.27765 10.6341 8.4581 10.8994 8.72998 11.012L8.92132 10.55ZM8.777 10.3353L9.277 10.334L9.27631 10.0681L8.77631 10.0694L8.27631 10.0707L8.277 10.3366L8.777 10.3353ZM8.77631 10.0694L9.17475 9.76735L8.77217 9.23633L8.37373 9.5384L7.97529 9.84047L8.37787 10.3715L8.77631 10.0694ZM8.37373 9.5384L8.02018 9.18485L7.44772 9.7573L7.80128 10.1109L8.15483 10.4644L8.72728 9.89196L8.37373 9.5384ZM7.80128 10.1109L7.44772 9.7573C7.41021 9.79482 7.3592 9.81594 7.30616 9.81594L7.30616 10.3159L7.30616 10.8159C7.62443 10.8159 7.92979 10.6894 8.15483 10.4644L7.80128 10.1109ZM7.30616 10.3159L7.30637 9.81594C7.25272 9.81592 7.20211 9.79477 7.16511 9.75781L6.81174 10.1115L6.45837 10.4653C6.68373 10.6904 6.98876 10.8158 7.30595 10.8159L7.30616 10.3159ZM6.81174 10.1115L7.16723 9.75994L5.91806 8.49695L5.56257 8.84856L5.20707 9.20016L6.45625 10.4632L6.81174 10.1115ZM5.56257 8.84856L5.91619 8.49508C5.87862 8.45749 5.85748 8.40635 5.85748 8.35345H5.35748H4.85748C4.85748 8.67174 4.98409 8.9771 5.20894 9.20204L5.56257 8.84856ZM5.35748 8.35345L5.85748 8.35349C5.85748 8.30046 5.87865 8.24936 5.91615 8.21186L5.56257 7.85833L5.20898 7.50481C4.98401 7.72982 4.85751 8.03521 4.85748 8.3534L5.35748 8.35345ZM5.56257 7.85833L5.91612 8.21189L8.22595 5.90205L7.8724 5.5485L7.51885 5.19494L5.20901 7.50478L5.56257 7.85833ZM5.89264 8.18841L5.53901 7.83494C5.40159 7.97241 5.32433 8.15896 5.32428 8.35331L5.82428 8.35345L6.32428 8.35359C6.32426 8.42425 6.29625 8.49188 6.24627 8.54188L5.89264 8.18841ZM5.82428 8.35345L5.32428 8.35345C5.32428 8.54813 5.40178 8.73456 5.53887 8.87182L5.89264 8.51848L6.24641 8.16515C6.29611 8.21491 6.32428 8.28243 6.32428 8.35345L5.82428 8.35345ZM5.89264 8.51848L5.5357 8.86862L5.96245 9.30366L6.31939 8.95352L6.67633 8.60338L6.24958 8.16835L5.89264 8.51848ZM6.31939 8.95352L5.96584 8.59997L5.96307 8.60273L6.31663 8.95628L6.67018 9.30984L6.67294 9.30707L6.31939 8.95352ZM6.31663 8.95628L5.96307 9.30984L6.78826 10.135L7.14182 9.78147L7.49537 9.42792L6.67018 8.60273L6.31663 8.95628ZM7.14182 9.78147L6.78882 10.1356C6.92567 10.272 7.1119 10.3498 7.30685 10.3498L7.30685 9.84983L7.30685 9.34983C7.37828 9.34983 7.44543 9.37813 7.49481 9.42736L7.14182 9.78147ZM7.30685 9.84983L7.3077 10.3498C7.50085 10.3495 7.68758 10.2729 7.82544 10.135L7.47189 9.78147L7.11834 9.42792C7.16887 9.37738 7.23633 9.34995 7.306 9.34983L7.30685 9.84983ZM7.47189 9.78147L7.82544 10.135L10.1353 7.82519L9.78173 7.47163L9.42817 7.11808L7.11834 9.42792L7.47189 9.78147ZM9.78173 7.47163L10.1355 7.82499C10.2728 7.68756 10.35 7.50105 10.3501 7.30695L9.85009 7.3066L9.35009 7.30624C9.35014 7.23571 9.37803 7.16828 9.42798 7.11828L9.78173 7.47163ZM9.85009 7.3066L10.3501 7.3066C10.3501 7.11164 10.2723 6.92541 10.1358 6.78856L9.78173 7.14156L9.42762 7.49456C9.37839 7.44517 9.35009 7.37803 9.35009 7.3066L9.85009 7.3066ZM9.78173 7.14156L10.1353 6.78801L9.64017 6.29289L9.28661 6.64645L8.93306 7L9.42817 7.49511L9.78173 7.14156ZM9.28661 6.64645L9.64336 6.29612L8.8893 5.52824L8.53255 5.87857L8.1758 6.2289L8.92987 6.99678L9.28661 6.64645ZM8.53255 5.87857L8.88588 5.5248C8.74863 5.38772 8.5622 5.31021 8.36751 5.31021L8.36751 5.81021L8.36752 6.31021C8.2965 6.31021 8.22897 6.28204 8.17922 6.23235L8.53255 5.87857ZM8.36751 5.81021L8.36711 5.31021C8.17325 5.31036 7.9866 5.38734 7.84892 5.52502L8.20248 5.87857L8.55603 6.23213C8.50578 6.28238 8.43815 6.31015 8.36791 6.31021L8.36751 5.81021ZM8.20248 5.87857L7.84892 5.52502L5.53909 7.83486L5.89264 8.18841L6.24619 8.54196L8.55603 6.23213L8.20248 5.87857Z'
      fill='var(--icon)'
    />
  </svg>

export const Assets = ({ size = '14' }: IconInterface) =>
  <svg
    fill='currentColor'
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      clip-rule='evenodd'
      d='M5.51397 3.82297C6.12358 2.72568 7.70167 2.72568 8.31128 3.82297L10.6216 7.98158C11.2141 9.04803 10.4429 10.3586 9.22297 10.3586H4.60229C3.38231 10.3586 2.61116 9.04803 3.20363 7.98158L5.51397 3.82297ZM8.88306 8.55861L6.91263 5.01183L4.94219 8.55861H8.88306ZM14.8 6.9C14.8 5.7402 15.7402 4.8 16.9 4.8C18.0598 4.8 19 5.7402 19 6.9C19 8.0598 18.0598 9 16.9 9C15.7402 9 14.8 8.0598 14.8 6.9ZM16.9 3C14.7461 3 13 4.74609 13 6.9C13 9.05391 14.7461 10.8 16.9 10.8C19.0539 10.8 20.8 9.05391 20.8 6.9C20.8 4.74609 19.0539 3 16.9 3ZM20.25 15.375C20.6987 14.9263 20.6987 14.1987 20.25 13.75C19.8013 13.3013 19.0737 13.3013 18.625 13.75L17 15.375L15.375 13.75C14.9263 13.3013 14.1987 13.3013 13.75 13.75C13.3013 14.1987 13.3013 14.9263 13.75 15.375L15.375 17L13.75 18.625C13.3013 19.0737 13.3013 19.8013 13.75 20.25C14.1987 20.6987 14.9263 20.6987 15.375 20.25L17 18.625L18.625 20.25C19.0737 20.6987 19.8013 20.6987 20.25 20.25C20.6987 19.8013 20.6987 19.0737 20.25 18.625L18.625 17L20.25 15.375ZM6 13C5.20435 13 4.44129 13.3161 3.87868 13.8787C3.31607 14.4413 3 15.2044 3 16V18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21H8C8.79565 21 9.55871 20.6839 10.1213 20.1213C10.6839 19.5587 11 18.7957 11 18V16C11 15.2043 10.6839 14.4413 10.1213 13.8787C9.55871 13.3161 8.79565 13 8 13H6ZM5.29289 15.2929C5.48043 15.1054 5.73478 15 6 15H8C8.26522 15 8.51957 15.1054 8.70711 15.2929C8.89464 15.4804 9 15.7348 9 16V18C9 18.2652 8.89464 18.5196 8.70711 18.7071C8.51957 18.8946 8.26522 19 8 19H6C5.73478 19 5.48043 18.8946 5.29289 18.7071C5.10536 18.5196 5 18.2652 5 18V16C5 15.7348 5.10536 15.4804 5.29289 15.2929Z'
      fill='currentColor'
      fill-rule='evenodd'
    />
  </svg>

export const GitReference = ({ size = '14' }: IconInterface) =>
  <svg
    fill='currentColor'
    height={size}
    viewBox='0 0 18 18'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.00049 16.9071C8.39316 16.9071 7.78583 16.6756 7.32273 16.2134L1.78747 10.6782C1.34621 10.2369 1.09283 9.62484 1.09283 9.00043V5.04708C1.09283 2.86637 2.86643 1.09277 5.04714 1.09277H9.00523C9.6287 1.09277 10.2389 1.34614 10.6792 1.78931L16.2135 7.32362C17.1387 8.24886 17.1387 9.7539 16.2135 10.6782L10.6782 16.2134C10.2161 16.6756 9.60877 16.9071 9.00049 16.9071ZM5.04714 2.67468C3.73853 2.67468 2.67475 3.73846 2.67475 5.04708V9.00138C2.67475 9.21015 2.7592 9.41323 2.90534 9.55936L8.44155 15.0956C8.74997 15.404 9.25101 15.404 9.55943 15.0956L15.0947 9.56031C15.4031 9.2519 15.4031 8.75085 15.0947 8.44244L9.55943 2.90718C9.41234 2.75914 9.21021 2.67563 9.00334 2.67563H5.04619L5.04714 2.67468ZM5.05473 5.83756C4.61821 5.83756 4.2595 5.4836 4.2595 5.04708C4.2595 4.61056 4.60967 4.25659 5.04619 4.25659H5.05378C5.4903 4.25659 5.84426 4.61056 5.84426 5.04708C5.84426 5.4836 5.4903 5.83756 5.05378 5.83756H5.05473Z'
      fill='currentColor'
    />
    <path
      d='M4.73488 8.51698L2.44555 8.51697L2.44555 9.5553L4.79799 9.55531C4.85174 9.65274 4.91998 9.7442 5.00259 9.82684C5.3442 10.1684 5.83832 10.262 6.26512 10.1103L7.80945 11.6547C7.65759 12.0815 7.75172 12.576 8.09341 12.9177C8.56653 13.3908 9.33362 13.3908 9.80674 12.9177C10.2796 12.4445 10.2798 11.6774 9.80674 11.2043C9.46519 10.8628 8.97049 10.7688 8.54373 10.9204L7.1782 9.55483L10.911 9.55483C10.9627 9.64385 11.0255 9.72863 11.1017 9.80485C11.5749 10.2778 12.342 10.2779 12.8151 9.80485C13.2881 9.33179 13.288 8.56466 12.8151 8.09152C12.3419 7.61839 11.5749 7.61839 11.1017 8.09152C10.9768 8.21644 10.8853 8.3619 10.8264 8.51698L6.9822 8.5165C6.92306 8.37002 6.83467 8.23225 6.71593 8.11351C6.24287 7.64057 5.4757 7.64065 5.00259 8.11351C4.88363 8.23247 4.79402 8.37019 4.73488 8.51698Z'
      fill='currentColor'
    />
  </svg>
